import React__default, { Component, createElement } from 'react';
import PropTypes, { string, func, bool, array } from 'prop-types';
import moment from 'moment';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { findDOMNode } from 'react-dom';

/* loaded by smart-asset */
require("../src/index.scss");

/* loaded by smart-asset */
require("../src/components/TitleDescription/TitleDescription.scss");

var _jsxFileName = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/TitleDescription/TitleDescription.js";
const TitleDescription = props => {
  const {
    title,
    description,
    color,
    link,
    descriptionClass,
    titleClass
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: `title_container ${color}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `title ${titleClass}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: `description ${descriptionClass}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }, description, /*#__PURE__*/React__default.createElement("span", {
    className: "link",
    __self: undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, link)));
  return Dom;
};
TitleDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  descriptionClass: PropTypes.string,
  titleClass: PropTypes.string
};
TitleDescription.defaultProps = {
  title: '',
  description: '',
  descriptionClass: '',
  titleClass: ''
};

/* loaded by smart-asset */
require("../src/components/DeliveryPlan/DeliveryPlan.scss");

var _jsxFileName$1 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/DeliveryPlan/DeliveryPlan.js";
const DeliveryPlan = props => {
  const {
    submitClick,
    term,
    perWeekDays,
    termonClick,
    perWeekDaysonClick
  } = props;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "deliveryplan",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: "Subscribe",
    description: "Subscribe for food delivery",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "deliveryplan__term",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ToggleTabs, {
    data: term,
    headingText: "Term",
    onClick: termonClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 26,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "deliveryplan__term",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 28,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ToggleTabs, {
    id: "delivery",
    data: perWeekDays,
    headingText: "Delivery per week",
    onClick: perWeekDaysonClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 29,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "deliveryplan__total",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 36,
      columnNumber: 7
    }
  }, "Total: AED 2,500"), /*#__PURE__*/React__default.createElement("div", {
    className: "deliveryplan__button",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 37,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: "next",
    size: "big",
    type: "block",
    onClick: submitClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 38,
      columnNumber: 9
    }
  })));
};
DeliveryPlan.propTypes = {
  submitClick: PropTypes.func,
  termonClick: PropTypes.func,
  perWeekDaysonClick: PropTypes.func,
  term: PropTypes.arrayOf(PropTypes.shape({})),
  perWeekDays: PropTypes.arrayOf(PropTypes.shape({}))
};
DeliveryPlan.defaultProps = {
  submitClick: () => {},
  termonClick: () => {},
  perWeekDaysonClick: () => {},
  term: [],
  perWeekDays: []
};

/* loaded by smart-asset */
require("../src/components/Loader/Loader.scss");

var _jsxFileName$2 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Loader/Loader.js";
const Loader = props => {
  const {
    fitContent
  } = props;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `loader_wrapper ${fitContent}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `loader ${fitContent}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 10,
      columnNumber: 7
    }
  }));
};
Loader.propTypes = {
  /**
   * Value `full` sets `height: 100%`
   */
  fitContent: string
};
Loader.defaultProps = {
  fitContent: ''
};

/* loaded by smart-asset */
require("../src/components/Button/Button.scss");

var _jsxFileName$3 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Button/Button.js";
/**
 * Default Button Component
 */

const Button = props => {
  const {
    text,
    className,
    color,
    onClick,
    disabled,
    size,
    leftContent,
    rightContent,
    showloader
  } = props;
  const customClassName = ['button', color, size, className].toString().replace(/,+/g, ' ').trim();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showloader ? /*#__PURE__*/React__default.createElement(Loader, {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 32,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: customClassName,
    onClick: onClick,
    disabled: disabled,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 34,
      columnNumber: 9
    }
  }, leftContent !== undefined && /*#__PURE__*/React__default.createElement("span", {
    className: "button__leftContent",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 41,
      columnNumber: 13
    }
  }, leftContent), text, rightContent !== undefined && /*#__PURE__*/React__default.createElement("span", {
    className: "button__rightContent",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 45,
      columnNumber: 13
    }
  }, rightContent)));
};
Button.propTypes = {
  /**
   * Text to display
   */
  text: string,
  className: string,
  color: string,
  onClick: func,

  /**
   * Show `<Loader/>` component
   *
   // TODO: use camelCase for this prop
   */
  showloader: bool
};
Button.defaultProps = {
  text: 'Button',
  className: '',
  color: '',
  showloader: false
};

/* loaded by smart-asset */
require("../src/components/AutoSuggestion/AutoSuggestion.scss");

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

var arrays = shallowEqualArrays;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var dist = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

var objectAssign = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};

var dist$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }



var _objectAssign2 = _interopRequireDefault(objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];
});

unwrapExports(dist$1);

var compareObjects_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}
});

unwrapExports(compareObjects_1);

var SectionTitle_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _compareObjects2 = _interopRequireDefault(compareObjects_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(React__default.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;
});

unwrapExports(SectionTitle_1);

var Item_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _compareObjects2 = _interopRequireDefault(compareObjects_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(React__default.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;
});

unwrapExports(Item_1);

var ItemsList_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _Item2 = _interopRequireDefault(Item_1);



var _compareObjects2 = _interopRequireDefault(compareObjects_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(React__default.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;
});

unwrapExports(ItemsList_1);

var Autowhatever_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _sectionIterator2 = _interopRequireDefault(dist);



var _reactThemeable2 = _interopRequireDefault(dist$1);



var _SectionTitle2 = _interopRequireDefault(SectionTitle_1);



var _ItemsList2 = _interopRequireDefault(ItemsList_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }

    // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(React__default.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2.default.object, // Arbitrary container props
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;
});

unwrapExports(Autowhatever_1);

var dist$2 = Autowhatever_1.default;

var theme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};
});

unwrapExports(theme);
var theme_1 = theme.defaultTheme;
var theme_2 = theme.mapToAutowhateverTheme;

var Autosuggest_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _arrays2 = _interopRequireDefault(arrays);



var _reactAutowhatever2 = _interopRequireDefault(dist$2);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme$1 = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, theme.mapToAutowhateverTheme)(theme$1),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(React__default.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;
});

unwrapExports(Autosuggest_1);

var dist$3 = Autosuggest_1.default;

/* loaded by smart-asset */
var DownArrowSvg = require("../src/assets/down-arrow.svg");

var _jsxFileName$4 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/AutoSuggestion/AutoSuggestion.js";
class AutoSuggestion extends Component {
  constructor(props) {
    super(props);

    this.onFocus = e => {
      const {
        onFocus
      } = this.props;
      this.setState({
        inputFocus: 'active'
      });
      const {
        target
      } = e;
      const {
        value,
        id
      } = target;
      if (onFocus) onFocus(id);
      this.onSuggestionsFetchRequested({
        value
      });
    };

    this.onChange = (event, {
      newValue
    }) => {
      const {
        onChange,
        id,
        required,
        validationChange
      } = this.props;
      this.setState({
        value: newValue
      });
      onChange(id, newValue, event);

      if (required && newValue) {
        const validation = !newValue;
        validationChange(id, validation);
      }
    };

    this.onSuggestionsFetchRequested = ({
      value
    }) => {
      const {
        getSuggestions,
        suggestionList
      } = this.props;
      this.setState({
        suggestions: getSuggestions(value, suggestionList)
      });
    };

    this.shouldRenderSuggestions = value => {
      return value.trim().length >= 0;
    };

    this.onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: []
      });
    };

    this.onSuggestionSelected = (event, {
      suggestion,
      suggestionValue
    }) => {
      // console.log(suggestion, suggestionValue, suggestionIndex, sectionIndex, method);
      const {
        onChange,
        id
      } = this.props;
      onChange(id, suggestionValue, suggestion, event);
    };

    this.onBlur = () => {
      if (this.input.value) this.setState({
        inputFocus: 'hasvalue'
      });else if (!this.input.value) {
        this.setState({
          inputFocus: ''
        });
      }
    };

    this.storeInputReference = autosuggest => {
      if (autosuggest !== null) {
        this.input = autosuggest.input;
      }
    };

    this.autosuggestLabelClick = () => {
      this.setState({
        inputFocus: 'active'
      });
      if (this.input) this.input.focus();
    };

    this.state = {
      value: '',
      suggestions: []
    };
  }

  componentDidMount() {
    const {
      value,
      currentFieldFocus,
      id
    } = this.props;

    if (currentFieldFocus === id) {
      if (this.input) this.input.focus();
    }

    if (value && currentFieldFocus !== id) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }

    if (!value) {
      this.setState({
        inputFocus: ''
      });
    }

    this.setState({
      value
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      value,
      currentFieldFocus,
      id
    } = nextProps;

    if (currentFieldFocus === id) {
      this.input.focus();
      this.setState({
        inputFocus: 'active'
      });
    }

    if (value && currentFieldFocus !== id) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }

    if (!value) {
      this.setState({
        inputFocus: ''
      });
    }

    this.setState({
      value
    });
  }

  render() {
    const {
      value,
      suggestions,
      inputFocus
    } = this.state;
    const {
      placeholderText,
      id,
      getSuggestionValue,
      renderSuggestion,
      multiSection,
      getSectionSuggestions,
      renderSectionTitle,
      label,
      disabled,
      validation
    } = this.props;
    const inputProps = {
      placeholder: placeholderText,
      value,
      id,
      label,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      disabled
    };
    const validationClassName = validation && 'error';
    return /*#__PURE__*/React__default.createElement("div", {
      className: `autosuggest ${inputFocus} ${validationClassName}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$4,
        lineNumber: 134,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "autosuggest-label",
      role: "presentation",
      onClick: () => this.autosuggestLabelClick(),
      __self: this,
      __source: {
        fileName: _jsxFileName$4,
        lineNumber: 135,
        columnNumber: 9
      }
    }, label), /*#__PURE__*/React__default.createElement(dist$3, {
      multiSection: multiSection,
      suggestions: suggestions,
      shouldRenderSuggestions: this.shouldRenderSuggestions,
      onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.onSuggestionsClearRequested,
      getSuggestionValue: getSuggestionValue,
      renderSuggestion: renderSuggestion,
      inputProps: inputProps,
      renderSectionTitle: renderSectionTitle,
      getSectionSuggestions: getSectionSuggestions,
      onSuggestionSelected: this.onSuggestionSelected,
      ref: this.storeInputReference,
      __self: this,
      __source: {
        fileName: _jsxFileName$4,
        lineNumber: 142,
        columnNumber: 9
      }
    }), /*#__PURE__*/React__default.createElement("img", {
      src: DownArrowSvg,
      alt: "down-arrow",
      className: "autosuggest_icon",
      __self: this,
      __source: {
        fileName: _jsxFileName$4,
        lineNumber: 156,
        columnNumber: 9
      }
    }));
  }

}

// TODO Refactor components that use this
const getCurrency = () => {
  return 'AED';
};

const LocalStorage = {
  getCurrency
};

/* loaded by smart-asset */
require("../src/components/CreditHistory/CreditHistory.scss");

var _jsxFileName$5 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/CreditHistory/CreditHistory.js";
const CreditHistory = props => {
  const {
    referralTotalCredits,
    referralHistory
  } = props;
  const {
    t
  } = useTranslation();
  const columns = [{
    title: 'email',
    key: 'email'
  }, {
    title: 'date',
    key: 'credited_at',
    head_classname: 'u_text_right',
    render: item => /*#__PURE__*/React__default.createElement("div", {
      className: "u_text_right",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$5,
        lineNumber: 22,
        columnNumber: 9
      }
    }, moment(item).format('DD MMMM, YYYY'))
  }, {
    title: 'amount',
    key: 'amount',
    head_classname: 'u_text_right',
    render: item => /*#__PURE__*/React__default.createElement("div", {
      className: "u_text_right credithistory__table_AED",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$5,
        lineNumber: 32,
        columnNumber: 9
      }
    }, `+${LocalStorage.getCurrency()} ${item}`)
  }];
  let mobileTableView = null;

  if (referralHistory && referralHistory.length && !(window.innerWidth > 768)) {
    mobileTableView = referralHistory.map(data => {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "credithistory__table_list",
        key: data.uuid,
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 40,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "credithistory__table_list_left",
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 41,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 42,
          columnNumber: 13
        }
      }, data.email), /*#__PURE__*/React__default.createElement("div", {
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 43,
          columnNumber: 13
        }
      }, moment(data.date, 'MM-DD-YYYY').format('DD MMMM, YYYY'))), /*#__PURE__*/React__default.createElement("div", {
        className: "credithistory__table_list_right",
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 45,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "credithistory__table_AED",
        __self: undefined,
        __source: {
          fileName: _jsxFileName$5,
          lineNumber: 46,
          columnNumber: 13
        }
      }, `+${LocalStorage.getCurrency()} ${data.amount}`)));
    });
  } else if (!(referralHistory && referralHistory.length) && !(window.innerWidth > 768)) {
    mobileTableView = /*#__PURE__*/React__default.createElement("div", {
      className: "credithistory__table_list__noData",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$5,
        lineNumber: 58,
        columnNumber: 7
      }
    }, t('no_data'), " !!");
  }

  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 63,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory__table",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 64,
      columnNumber: 7
    }
  }, window.innerWidth > 768 ? /*#__PURE__*/React__default.createElement(Table, {
    columns: columns,
    data: referralHistory,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 66,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory__table_list_wrapper",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 68,
      columnNumber: 11
    }
  }, mobileTableView), /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory__table_total",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 73,
      columnNumber: 11
    }
  }, `${t('total')}: ${referralHistory && referralHistory.length} ${t('friends')}`), /*#__PURE__*/React__default.createElement("div", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 78,
      columnNumber: 11
    }
  }, `${t('total')}: ${LocalStorage.getCurrency()} ${referralTotalCredits}`)), referralHistory && referralHistory.length ? /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory__table_pagination",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 85,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "credithistory__table_pagination_btn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 86,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: "show more",
    size: "small",
    color: "lightgrey",
    type: "block",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 87,
      columnNumber: 15
    }
  }))) : ''));
  return Dom;
};
CreditHistory.propTypes = {
  referralTotalCredits: PropTypes.number,
  referralHistory: PropTypes.arrayOf(PropTypes.shape({}))
};
CreditHistory.defaultProps = {
  referralTotalCredits: 0
};

/* loaded by smart-asset */
require("../src/components/NutritionInsightAdvice/NutritionInsightAdvice.scss");

var _jsxFileName$6 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/NutritionInsightAdvice/NutritionInsightAdvice.js";
const NutritionInsightAdvice = props => {
  const {
    adviceData,
    insightData
  } = props;
  const adviceDom = adviceData.map(data => {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "nutrition-insights__list_item",
      key: data.uuid,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 12,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__title",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 13,
        columnNumber: 9
      }
    }, data.name), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__description",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 14,
        columnNumber: 9
      }
    }, data.description), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 17,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: "set nutritional limits",
      type: "block",
      size: "small",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 18,
        columnNumber: 11
      }
    })));
  });
  const insightDom = insightData.map(data => {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "nutrition-insights__list_item",
      key: data.uuid,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 26,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__title",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 27,
        columnNumber: 9
      }
    }, data.name), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__description",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 28,
        columnNumber: 9
      }
    }, data.description), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-insights__list_item__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 31,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: "noted",
      type: "block",
      size: "small",
      color: "lightgrey",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$6,
        lineNumber: 32,
        columnNumber: 11
      }
    })));
  });
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-insights",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-insights__heading",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 39,
      columnNumber: 7
    }
  }, "Advice"), /*#__PURE__*/React__default.createElement("ul", {
    className: "nutrition-insights__list u_list_style_none",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 40,
      columnNumber: 7
    }
  }, adviceDom), /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-insights__heading",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 43,
      columnNumber: 7
    }
  }, "Insights"), /*#__PURE__*/React__default.createElement("ul", {
    className: "nutrition-insights__list u_list_style_none",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 44,
      columnNumber: 7
    }
  }, insightDom));
  return Dom;
};
NutritionInsightAdvice.propTypes = {
  insightData: PropTypes.arrayOf(PropTypes.shape({})),
  adviceData: PropTypes.arrayOf(PropTypes.shape({}))
};
NutritionInsightAdvice.defaultProps = {
  insightData: [],
  adviceData: []
};

/* loaded by smart-asset */
require("../src/components/Accordion/Accordion.scss");

/* loaded by smart-asset */
var SettingIcon = require("../src/assets/settings-icon.svg");

var _temp,
    _jsxFileName$7 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Accordion/Accordion.js";
const componentClass = (_temp = class Accordion extends Component {
  constructor(props) {
    super(props);

    this.onClick = (event, label) => {
      if (event.target !== event.currentTarget) {
        return;
      }

      const {
        openSections
      } = this.state;
      const isOpen = openSections[label];
      this.setState({
        openSections: {
          [label]: !isOpen
        }
      });
    };

    this.state = {
      openSections: {}
    };
    this.tooltipRef = React__default.createRef();
  }

  render() {
    const {
      children,
      tooltipListData,
      t
    } = this.props;
    const {
      openSections
    } = this.state;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "accordion",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 39,
        columnNumber: 7
      }
    }, children.map(child => /*#__PURE__*/React__default.createElement("div", {
      key: child.props.label,
      className: "accordion_content",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 41,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      role: "presentation",
      onClick: event => this.onClick(event, child.props.label),
      className: "accordion_content__header",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 42,
        columnNumber: 13
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "accordion_content__header_label",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 47,
        columnNumber: 15
      }
    }, child.props.displayLabel), /*#__PURE__*/React__default.createElement("div", {
      className: "accordion_content__header_icon",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 50,
        columnNumber: 15
      }
    }, !openSections[child.props.label] && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "accordion_content__header_icon_label",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 55,
        columnNumber: 21
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "u_mobile_display_none",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 56,
        columnNumber: 23
      }
    }, t('balance'), ":"), /*#__PURE__*/React__default.createElement("div", {
      className: "accordion_content__header_icon_label_sub",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 59,
        columnNumber: 23
      }
    }, `${LocalStorage.getCurrency()} ${child.props.apiData && child.props.apiData.balance}`)), /*#__PURE__*/React__default.createElement("span", {
      onClick: event => this.onClick(event, child.props.label),
      className: "accordion_content__header_icon__plus",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 66,
        columnNumber: 21
      }
    })), openSections[child.props.label] && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tooltip, {
      listData: tooltipListData,
      apiData: child.props.apiData,
      position: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 76,
        columnNumber: 21
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: SettingIcon,
      alt: "seting",
      className: "accordion_content__header_icon__setting",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 81,
        columnNumber: 23
      }
    })), /*#__PURE__*/React__default.createElement("span", {
      onClick: event => this.onClick(event, child.props.label),
      className: "accordion_content__header_icon__minus",
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 88,
        columnNumber: 21
      }
    })))), openSections[child.props.label] && /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$7,
        lineNumber: 97,
        columnNumber: 15
      }
    }, child.props.children))));
  }

}, _temp);
const Accordion = withTranslation()(componentClass);
Accordion.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired
};
Accordion.defaultProps = {
  children: {}
};

/* loaded by smart-asset */
require("../src/components/Carousel/Carousel.scss");

var _jsxFileName$8 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Carousel/Carousel.js";
class Carousel extends Component {
  constructor(props) {
    super(props);
    this.ref = React__default.createRef();
    this.state = {
      activeIndex: 0
    };
  }

  componentDidMount() {
    const self = this;
    this.interval = setInterval(() => self.setIndex(), 5000);
  }

  componentWillUnmount() {
    const self = this;
    clearInterval(self.interval);
  }

  setIndex() {
    let {
      activeIndex
    } = this.state;
    const {
      carouselData
    } = this.props;

    if (activeIndex !== carouselData.length - 1) {
      activeIndex += 1;
    } else {
      activeIndex = 0;
    }

    this.setState({
      activeIndex
    });
  }

  render() {
    const {
      activeIndex
    } = this.state;
    const {
      carouselData
    } = this.props;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "slider",
      __self: this,
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 40,
        columnNumber: 9
      }
    }, carouselData.map((data, index) => {
      return /*#__PURE__*/React__default.createElement("div", {
        key: data.key,
        className: activeIndex === index ? `slider_item slider_item-bg${index + 1} active` : `slider_item slider_item-bg${index + 1}`,
        __self: this,
        __source: {
          fileName: _jsxFileName$8,
          lineNumber: 43,
          columnNumber: 15
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "slider_item_content",
        __self: this,
        __source: {
          fileName: _jsxFileName$8,
          lineNumber: 51,
          columnNumber: 17
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "slider_item_content_title",
        __self: this,
        __source: {
          fileName: _jsxFileName$8,
          lineNumber: 52,
          columnNumber: 19
        }
      }, data.title), /*#__PURE__*/React__default.createElement("div", {
        className: "slider_item_content_description",
        __self: this,
        __source: {
          fileName: _jsxFileName$8,
          lineNumber: 53,
          columnNumber: 19
        }
      }, data.description)));
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "slider_indicator",
      __self: this,
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 61,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `slider_indicator_item ${activeIndex === 0 ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 62,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      className: `slider_indicator_item ${activeIndex === 1 ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 67,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      className: `slider_indicator_item ${activeIndex === 2 ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$8,
        lineNumber: 72,
        columnNumber: 11
      }
    })));
  }

}
Carousel.propTypes = {
  /**
   * Array of objects (`{ title, description }`)
   */
  carouselData: array
};
Carousel.defaultProps = {
  carouselData: [{
    title: 'Title',
    description: 'Description'
  }]
};

/* loaded by smart-asset */
require("../src/components/ContentDivider/ContentDivider.scss");

var _jsxFileName$9 = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ContentDivider/ContentDivider.js";
const ContentDivider = props => {
  const {
    lineDivider
  } = props;
  let Dom = null;

  if (lineDivider) {
    Dom = /*#__PURE__*/React__default.createElement("div", {
      className: "contentDivider line",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 8,
        columnNumber: 11
      }
    });
  } else {
    Dom = /*#__PURE__*/React__default.createElement("div", {
      className: "contentDivider",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 11,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "contentDivider_line",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 12,
        columnNumber: 9
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "contentDivider_content",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 13,
        columnNumber: 9
      }
    }, "Or"), /*#__PURE__*/React__default.createElement("div", {
      className: "contentDivider_line",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 14,
        columnNumber: 9
      }
    }));
  }

  return Dom;
};

/* loaded by smart-asset */
require("../src/components/CreateNewPassword/CreateNewPassword.scss");

var _jsxFileName$a = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/CreateNewPassword/CreateNewPassword.js";
const CreateNewPassword = props => {
  const {
    onClick,
    inputvalue,
    validation,
    onChangeInput,
    validationChangeHandler,
    onFocusInput,
    currentFieldFocus,
    btnshowloader
  } = props;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: t('create_new_password'),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 26,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "resetPassword_input",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
    id: "newPassword",
    label: t('new_password'),
    type: "password",
    required: true,
    value: inputvalue.newPassword,
    onChange: onChangeInput,
    validation: validation.newPassword,
    validationChange: validationChangeHandler,
    onFocus: onFocusInput,
    currentFieldFocus: currentFieldFocus,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
    id: "confirmNewPassword",
    label: t('confirm_new_Password'),
    type: "password",
    required: true,
    value: inputvalue.confirmNewPassword,
    onChange: onChangeInput,
    validation: validation.confirmNewPassword,
    validationChange: validationChangeHandler,
    onFocus: onFocusInput,
    currentFieldFocus: currentFieldFocus,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 40,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClick,
    text: t('save_new_password'),
    type: "block",
    size: "big",
    showloader: btnshowloader,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 52,
      columnNumber: 9
    }
  })));
};
CreateNewPassword.propTypes = {
  onClick: PropTypes.func,
  inputvalue: PropTypes.shape({}),
  validation: PropTypes.shape({}),
  onChangeInput: PropTypes.func,
  validationChangeHandler: PropTypes.func,
  onFocusInput: PropTypes.func,
  currentFieldFocus: PropTypes.string,
  btnshowloader: PropTypes.bool
};
CreateNewPassword.defaultProps = {
  onClick: () => {},
  inputvalue: {},
  validation: {},
  onChangeInput: () => {},
  validationChangeHandler: () => {},
  onFocusInput: () => {},
  currentFieldFocus: '',
  btnshowloader: false
};

/* loaded by smart-asset */
require("../src/components/CustomTabs/CustomTabs.scss");

var _jsxFileName$b = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/CustomTabs/CustomTabs.js";
const CustomTabs = props => {
  const {
    data,
    onClick,
    color
  } = props;
  const listDom = data.map(item => {
    return /*#__PURE__*/React__default.createElement("li", {
      key: `${item.key}`,
      className: `customTabs_list_item ${color} ${item.status}`,
      role: "presentation",
      onClick: () => onClick(item),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$b,
        lineNumber: 11,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "customTabs_list_item_text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$b,
        lineNumber: 17,
        columnNumber: 9
      }
    }, item.displayName));
  });
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "customTabs",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$b,
      lineNumber: 23,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "u_list_style_none customTabs_list",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$b,
      lineNumber: 24,
      columnNumber: 7
    }
  }, listDom));
  return Dom;
};
CustomTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    displayName: PropTypes.string,
    index: PropTypes.number
  })),
  onClick: PropTypes.func
};
CustomTabs.defaultProps = {
  data: [],
  onClick: () => {}
};

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + required > 1 ? 's' : '' + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * var result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * var result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * var result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * var result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var MILLISECONDS_IN_MINUTE = 60000;

function getDateMillisecondsPart(date) {
  return date.getTime() % MILLISECONDS_IN_MINUTE;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$1);
}

var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  var desiredMonth = date.getMonth() + amount;
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
  return date;
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * var result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * var result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * var result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */

function getWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * var result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * var result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * var result = getISOWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  return year;
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date)) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/**
 * @name min
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */

function isWithinInterval(dirtyDate, dirtyInterval) {
  requiredArgs(2, arguments);
  var interval = dirtyInterval || {};
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2 + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   toDate('2016-01-01')
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;

  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1 // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale$1.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).reverse();
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

var MILLISECONDS_IN_HOUR$2 = 3600000;
var MILLISECONDS_IN_MINUTE$3 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    result.setFullYear(dirtyDate.getUTCFullYear());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR$2 + minutes * MILLISECONDS_IN_MINUTE$3 + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR$2 + minutes * MILLISECONDS_IN_MINUTE$3);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex$1(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$1(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose$1;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr$2 = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr$2.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr$2.call(value) !== '[object Array]' &&
		toStr$2.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is

var numberIsNaN = function (value) {
	return value !== value;
};

var objectIs = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$3 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$3.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice$1.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice$1.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice$1.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr$4 = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag$1 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isRegex = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag$1) {
		return toStr$4.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && src(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};

var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$5 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$5.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty$1 = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty$1(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = commonjsGlobal.Symbol;


var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined$1;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$2 = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
var generatorFunction =  undefined$1;
var asyncFunction =  undefined$1;
var asyncGenFunction =  undefined$1;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%':  undefined$1,
	'%AsyncGenerator%':  undefined$1,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%':  undefined$1,
	'%AsyncIteratorPrototype%':  undefined$1,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined$1 : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%':  undefined$1,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%':  undefined$1,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined$1 : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined$1 : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined$1 : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined$1 : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined$1 : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined$1 : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
	'%SymbolPrototype%': hasSymbols$2 ? Symbol.prototype : undefined$1,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined$1,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet.prototype
};


var $replace = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

var GetIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

var callBind = function callBind() {
	return functionBind.apply($call, arguments);
};

var apply = function applyBind() {
	return functionBind.apply($apply, arguments);
};
callBind.apply = apply;

var $Object = Object;
var $TypeError$1 = TypeError;

var implementation$2 = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError$1('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD$1 = Object.getOwnPropertyDescriptor;
var $TypeError$2 = TypeError;

var polyfill = function getPolyfill() {
	if (!supportsDescriptors$1) {
		throw new $TypeError$2('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD$1(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation$2;
};

var supportsDescriptors$2 = defineProperties_1.supportsDescriptors;

var gOPD$1 = Object.getOwnPropertyDescriptor;
var defineProperty$2 = Object.defineProperty;
var TypeErr = TypeError;
var getProto$1 = Object.getPrototypeOf;
var regex = /a/;

var shim = function shimFlags() {
	if (!supportsDescriptors$2 || !getProto$1) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill$1 = polyfill();
	var proto = getProto$1(regex);
	var descriptor = gOPD$1(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill$1) {
		defineProperty$2(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill$1
		});
	}
	return polyfill$1;
};

var flagsBound = callBind(implementation$2);

defineProperties_1(flagsBound, {
	getPolyfill: polyfill,
	implementation: implementation$2,
	shim: shim
});

var regexp_prototype_flags = flagsBound;

var getDay$1 = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay$1.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$6 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$2 ? tryDateObject(value) : toStr$6.call(value) === dateClass;
};

var getTime$1 = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? objectIs(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? objectIs(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments$1(a) !== isArguments$1(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && regexp_prototype_flags(a) === regexp_prototype_flags(b);
  }

  if (isDateObject(a) && isDateObject(b)) {
    return getTime$1.call(a) === getTime$1.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

var deepEqual_1 = deepEqual;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$1(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$3 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$1(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$3(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$3(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$3({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$3({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$3({}, side, reference[side]),
      end: defineProperty$3({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
//# sourceMappingURL=popper.js.map

var key = '__global_unique_id__';

var gud = function() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var implementation$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _gud2 = _interopRequireDefault(gud);



var _warning2 = _interopRequireDefault(warning_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (process.env.NODE_ENV !== 'production') {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(React__default.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(React__default.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];
});

unwrapExports(implementation$3);

var lib = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default);



var _implementation2 = _interopRequireDefault(implementation$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];
});

var createContext = unwrapExports(lib);

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty(assertThisInitialized(_this), "referenceNode", void 0);

    defineProperty(assertThisInitialized(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty(assertThisInitialized(_this), "state", {
      data: undefined,
      placement: undefined
    });

    defineProperty(assertThisInitialized(_this), "popperInstance", void 0);

    defineProperty(assertThisInitialized(_this), "popperNode", null);

    defineProperty(assertThisInitialized(_this), "arrowNode", null);

    defineProperty(assertThisInitialized(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    defineProperty(assertThisInitialized(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    defineProperty(assertThisInitialized(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    defineProperty(assertThisInitialized(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends_1({}, _this.props.modifiers, {
          arrow: _extends_1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    defineProperty(assertThisInitialized(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends_1({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    defineProperty(assertThisInitialized(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    defineProperty(assertThisInitialized(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    defineProperty(assertThisInitialized(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    defineProperty(assertThisInitialized(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    defineProperty(assertThisInitialized(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = assertThisInitialized(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });

    defineProperty(assertThisInitialized(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual_1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (process.env.NODE_ENV === "development") {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(Component);

defineProperty(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});
function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
      props = objectWithoutPropertiesLoose(_ref, ["referenceElement"]);

  return createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return createElement(InnerPopper, _extends_1({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty(assertThisInitialized(_this), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_1(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(Component);

function Reference(props) {
  return createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return createElement(InnerReference, _extends_1({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

function re(e){return (re="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ne(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function oe(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}function ae(e,t,r){return t&&oe(e.prototype,t),r&&oe(e,r),e}function se(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function pe(){return (pe=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e}).apply(this,arguments)}function ie(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n);}return r}function ce(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&de(e,t);}function le(e){return (le=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function de(e,t){return (de=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ue(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function he(e,t){return !t||"object"!=typeof t&&"function"!=typeof t?ue(e):t}function me(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function fe(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var ve={p:fe,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),o=n[1],a=n[2];if(!a)return me(e,t);switch(o){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",me(o,t)).replace("{{time}}",fe(a,t))}},ye=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function De(e){var t=e?"string"==typeof e||e instanceof String?parseISO(e):toDate(e):new Date;return we(t)?t:null}function ge(e,t,r,n){var a=null,s=Ie(r)||Ye(),p=!0;return Array.isArray(t)?(t.forEach((function(t){var r=parse(e,t,new Date,{locale:s});n&&(p=we(r)&&e===format(r,t,{awareOfUnicodeTokens:!0})),we(r)&&p&&(a=r);})),a):(a=parse(e,t,new Date,{locale:s}),n?p=we(a)&&e===format(a,t,{awareOfUnicodeTokens:!0}):we(a)||(t=t.match(ye).map((function(e){var t=e[0];if("p"===t||"P"===t){var r=ve[t];return s?r(e,s.formatLong):t}return e})).join(""),e.length>0&&(a=parse(e,t.slice(0,e.length),new Date)),we(a)||(a=new Date(e))),we(a)&&p?a:null)}function we(e){return isValid(e)&&isAfter(e,new Date("1/1/1000"))}function ke(e,t,r){if("en"===r)return format(e,t,{awareOfUnicodeTokens:!0});var n=Ie(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Ye()&&Ie(Ye())&&(n=Ie(Ye())),format(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function be(e,t){var r=t.hour,n=void 0===r?0:r,o=t.minute,a=void 0===o?0:o,s=t.second;return setHours(setMinutes(setSeconds(e,void 0===s?0:s),a),n)}function Ce(e,t){var r=Ie(t||Ye());return startOfWeek(e,{locale:r})}function _e(e){return startOfMonth(e)}function Se(e,t){return e&&t?isSameYear(e,t):!e&&!t}function Me(e,t){return e&&t?isSameMonth(e,t):!e&&!t}function Ee(e,t){return e&&t?isSameQuarter(e,t):!e&&!t}function Ne(e,t){return e&&t?isSameDay(e,t):!e&&!t}function Pe(e,t){return e&&t?isEqual(e,t):!e&&!t}function xe(e,t,r){var n,o=startOfDay(t),a=endOfDay(r);try{n=isWithinInterval(e,{start:o,end:a});}catch(e){n=!1;}return n}function Ye(){return ("undefined"!=typeof window?window:global).__localeId__}function Ie(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Le(e,t){return ke(setMonth(De(),e),"LLL",t)}function Fe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return je(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return Ne(e,t)}))||a&&!a.some((function(t){return Ne(e,t)}))||s&&!s(De(e))||!1}function We(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return je(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return Me(e,t)}))||a&&!a.some((function(t){return Me(e,t)}))||s&&!s(De(e))||!1}function Ae(e,t,r,n){var o=getYear(e),a=getMonth(e),s=getYear(t),p=getMonth(t),i=getYear(n);return o===s&&o===i?a<=r&&r<=p:o<s?i===o&&a<=r||i===s&&p>=r||i<s&&i>o:void 0}function Be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return je(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return Ee(e,t)}))||a&&!a.some((function(t){return Ee(e,t)}))||s&&!s(De(e))||!1}function Re(e,t,r,n){var o=getYear(e),a=getQuarter(e),s=getYear(t),p=getQuarter(t),i=getYear(n);return o===s&&o===i?a<=r&&r<=p:o<s?i===o&&a<=r||i===s&&p>=r||i<s&&i>o:void 0}function je(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&differenceInCalendarDays(e,r)<0||n&&differenceInCalendarDays(e,n)>0}function Ke(e,t){for(var r=t.length,n=0;n<r;n++)if(getHours(t[n])===getHours(e)&&getMinutes(t[n])===getMinutes(e))return !0;return !1}function He(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var o,a=De(),s=setHours(setMinutes(a,getMinutes(e)),getHours(e)),p=setHours(setMinutes(a,getMinutes(r)),getHours(r)),i=setHours(setMinutes(a,getMinutes(n)),getHours(n));try{o=!isWithinInterval(s,{start:p,end:i});}catch(e){o=!1;}return o}function Qe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subMonths(e,1);return r&&differenceInCalendarMonths(r,o)>0||n&&n.every((function(e){return differenceInCalendarMonths(e,o)>0}))||!1}function Ve(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addMonths(e,1);return r&&differenceInCalendarMonths(o,r)>0||n&&n.every((function(e){return differenceInCalendarMonths(o,e)>0}))||!1}function qe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subYears(e,1);return r&&differenceInCalendarYears(r,o)>0||n&&n.every((function(e){return differenceInCalendarYears(e,o)>0}))||!1}function Ue(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addYears(e,1);return r&&differenceInCalendarYears(o,r)>0||n&&n.every((function(e){return differenceInCalendarYears(o,e)>0}))||!1}function $e(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)>=0}));return min(n)}return r?min(r):t}function ze(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)<=0}));return max(n)}return r?max(r):t}function Ge(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",n=new Map,o=0,a=e.length;o<a;o++){var s=e[o];if(isDate(s)){var p=ke(s,"MM.dd.yyyy"),i=n.get(p)||[];i.includes(t)||(i.push(t),n.set(p,i));}else if("object"===re(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var m=ke(d[u],"MM.dd.yyyy"),f=n.get(m)||[];f.includes(l)||(f.push(l),n.set(m,f));}}}return n}function Je(e,t,r,n,o){for(var p=o.length,i=[],c=0;c<p;c++){var l=addMinutes(addHours(e,getHours(o[c])),getMinutes(o[c])),d=addMinutes(e,(r+1)*n);isAfter(l,t)&&isBefore(l,d)&&i.push(o[c]);}return i}function Xe(e){return e<10?"0".concat(e):"".concat(e)}function Ze(e,t,r,n){for(var o=[],a=0;a<2*t+1;a++){var s=e+t-a,p=!0;r&&(p=getYear(r)<=s),n&&p&&(p=getYear(n)>=s),p&&o.push(s);}return o}var et=onClickOutsideHOC(function(r){function n(t){var r;ne(this,n),se(ue(r=he(this,le(n).call(this,t))),"renderOptions",(function(){var t=r.props.year,n=r.state.yearsList.map((function(n){return React__default.createElement("div",{className:t===n?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:n,ref:n,onClick:r.onChange.bind(ue(r),n)},t===n?React__default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",n)})),o=r.props.minDate?getYear(r.props.minDate):null,a=r.props.maxDate?getYear(r.props.maxDate):null;return a&&r.state.yearsList.find((function(e){return e===a}))||n.unshift(React__default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:r.incrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),o&&r.state.yearsList.find((function(e){return e===o}))||n.push(React__default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:r.decrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),n})),se(ue(r),"onChange",(function(e){r.props.onChange(e);})),se(ue(r),"handleClickOutside",(function(){r.props.onCancel();})),se(ue(r),"shiftYears",(function(e){var t=r.state.yearsList.map((function(t){return t+e}));r.setState({yearsList:t});})),se(ue(r),"incrementYears",(function(){return r.shiftYears(1)})),se(ue(r),"decrementYears",(function(){return r.shiftYears(-1)}));var o=t.yearDropdownItemNumber,a=t.scrollableYearDropdown,s=o||(a?10:5);return r.state={yearsList:Ze(r.props.year,s,r.props.minDate,r.props.maxDate)},r}return ce(n,React__default.Component),ae(n,[{key:"render",value:function(){var r=classnames({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return React__default.createElement("div",{className:r},this.renderOptions())}}]),n}()),tt=function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(a)))),"state",{dropdownVisible:!1}),se(ue(n),"renderSelectOptions",(function(){for(var t=n.props.minDate?getYear(n.props.minDate):1900,r=n.props.maxDate?getYear(n.props.maxDate):2100,o=[],a=t;a<=r;a++)o.push(React__default.createElement("option",{key:a,value:a},a));return o})),se(ue(n),"onSelectChange",(function(e){n.onChange(e.target.value);})),se(ue(n),"renderSelectMode",(function(){return React__default.createElement("select",{value:n.props.year,className:"react-datepicker__year-select",onChange:n.onSelectChange},n.renderSelectOptions())})),se(ue(n),"renderReadView",(function(t){return React__default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return n.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},n.props.year))})),se(ue(n),"renderDropdown",(function(){return React__default.createElement(et,{key:"dropdown",ref:"options",year:n.props.year,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})})),se(ue(n),"renderScrollMode",(function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t})),se(ue(n),"onChange",(function(e){n.toggleDropdown(),e!==n.props.year&&n.props.onChange(e);})),se(ue(n),"toggleDropdown",(function(e){n.setState({dropdownVisible:!n.state.dropdownVisible},(function(){n.props.adjustDateOnChange&&n.handleYearChange(n.props.date,e);}));})),se(ue(n),"handleYearChange",(function(e,t){n.onSelect(e,t),n.setOpen();})),se(ue(n),"onSelect",(function(e,t){n.props.onSelect&&n.props.onSelect(e,t);})),se(ue(n),"setOpen",(function(){n.props.setOpen&&n.props.setOpen(!0);})),n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),r}(),rt=onClickOutsideHOC(function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(a)))),"renderOptions",(function(){return n.props.monthNames.map((function(t,r){return React__default.createElement("div",{className:n.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,ref:t,onClick:n.onChange.bind(ue(n),r)},n.props.month===r?React__default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),se(ue(n),"onChange",(function(e){return n.props.onChange(e)})),se(ue(n),"handleClickOutside",(function(){return n.props.onCancel()})),n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}()),nt=function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(a)))),"state",{dropdownVisible:!1}),se(ue(n),"renderSelectOptions",(function(t){return t.map((function(t,r){return React__default.createElement("option",{key:r,value:r},t)}))})),se(ue(n),"renderSelectMode",(function(t){return React__default.createElement("select",{value:n.props.month,className:"react-datepicker__month-select",onChange:function(e){return n.onChange(e.target.value)}},n.renderSelectOptions(t))})),se(ue(n),"renderReadView",(function(t,r){return React__default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:n.toggleDropdown},React__default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[n.props.month]))})),se(ue(n),"renderDropdown",(function(t){return React__default.createElement(rt,{key:"dropdown",ref:"options",month:n.props.month,monthNames:t,onChange:n.onChange,onCancel:n.toggleDropdown})})),se(ue(n),"renderScrollMode",(function(e){var t=n.state.dropdownVisible,r=[n.renderReadView(!t,e)];return t&&r.unshift(n.renderDropdown(e)),r})),se(ue(n),"onChange",(function(e){n.toggleDropdown(),e!==n.props.month&&n.props.onChange(e);})),se(ue(n),"toggleDropdown",(function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})})),n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){var t,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Le(e,r.props.locale)}:function(e){return t=e,n=r.props.locale,ke(setMonth(De(),t),"LLLL",n);var t,n;});switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode(n);break;case"select":t=this.renderSelectMode(n);}return React__default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),r}();function ot(e,t){for(var r=[],n=_e(e),o=_e(t);!isAfter(n,o);)r.push(De(n)),n=addMonths(n,1);return r}var at=onClickOutsideHOC(function(r){function n(t){var r;return ne(this,n),se(ue(r=he(this,le(n).call(this,t))),"renderOptions",(function(){return r.state.monthYearsList.map((function(t){var n=getTime(t),o=Se(r.props.date,t)&&Me(r.props.date,t);return React__default.createElement("div",{className:o?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:n,ref:n,onClick:r.onChange.bind(ue(r),n)},o?React__default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",ke(t,r.props.dateFormat))}))})),se(ue(r),"onChange",(function(e){return r.props.onChange(e)})),se(ue(r),"handleClickOutside",(function(){r.props.onCancel();})),r.state={monthYearsList:ot(r.props.minDate,r.props.maxDate)},r}return ce(n,React__default.Component),ae(n,[{key:"render",value:function(){var r=classnames({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return React__default.createElement("div",{className:r},this.renderOptions())}}]),n}()),st=function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(a)))),"state",{dropdownVisible:!1}),se(ue(n),"renderSelectOptions",(function(){for(var t=_e(n.props.minDate),r=_e(n.props.maxDate),o=[];!isAfter(t,r);){var a=getTime(t);o.push(React__default.createElement("option",{key:a,value:a},ke(t,n.props.dateFormat,n.props.locale))),t=addMonths(t,1);}return o})),se(ue(n),"onSelectChange",(function(e){n.onChange(e.target.value);})),se(ue(n),"renderSelectMode",(function(){return React__default.createElement("select",{value:getTime(_e(n.props.date)),className:"react-datepicker__month-year-select",onChange:n.onSelectChange},n.renderSelectOptions())})),se(ue(n),"renderReadView",(function(t){var r=ke(n.props.date,n.props.dateFormat,n.props.locale);return React__default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return n.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),se(ue(n),"renderDropdown",(function(){return React__default.createElement(at,{key:"dropdown",ref:"options",date:n.props.date,dateFormat:n.props.dateFormat,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})})),se(ue(n),"renderScrollMode",(function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t})),se(ue(n),"onChange",(function(e){n.toggleDropdown();var t=De(parseInt(e));Se(n.props.date,t)&&Me(n.props.date,t)||n.props.onChange(t);})),se(ue(n),"toggleDropdown",(function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})})),n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),r}(),pt=function(r){function n(){var r,o;ne(this,n);for(var a=arguments.length,s=new Array(a),p=0;p<a;p++)s[p]=arguments[p];return se(ue(o=he(this,(r=le(n)).call.apply(r,[this].concat(s)))),"dayEl",React__default.createRef()),se(ue(o),"handleClick",(function(e){!o.isDisabled()&&o.props.onClick&&o.props.onClick(e);})),se(ue(o),"handleMouseEnter",(function(e){!o.isDisabled()&&o.props.onMouseEnter&&o.props.onMouseEnter(e);})),se(ue(o),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),o.props.handleOnKeyDown(e);})),se(ue(o),"isSameDay",(function(e){return Ne(o.props.day,e)})),se(ue(o),"isKeyboardSelected",(function(){return !o.props.disabledKeyboardNavigation&&!o.props.inline&&!o.isSameDay(o.props.selected)&&o.isSameDay(o.props.preSelection)})),se(ue(o),"isDisabled",(function(){return Fe(o.props.day,o.props)})),se(ue(o),"isExcluded",(function(){return function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).excludeDates;return t&&t.some((function(t){return Ne(e,t)}))||!1}(o.props.day,o.props)})),se(ue(o),"getHighLightedClass",(function(e){var t=o.props,r=t.day,n=t.highlightDates;if(!n)return !1;var a=ke(r,"MM.dd.yyyy");return n.get(a)})),se(ue(o),"isInRange",(function(){var e=o.props,t=e.day,r=e.startDate,n=e.endDate;return !(!r||!n)&&xe(t,r,n)})),se(ue(o),"isInSelectingRange",(function(){var e=o.props,t=e.day,r=e.selectsStart,n=e.selectsEnd,a=e.selectingDate,s=e.startDate,p=e.endDate;return !(!r&&!n||!a||o.isDisabled())&&(r&&p&&(isBefore(a,p)||Pe(a,p))?xe(t,a,p):!(!n||!s||!isAfter(a,s)&&!Pe(a,s))&&xe(t,s,a))})),se(ue(o),"isSelectingRangeStart",(function(){if(!o.isInSelectingRange())return !1;var e=o.props,t=e.day,r=e.selectingDate,n=e.startDate;return Ne(t,e.selectsStart?r:n)})),se(ue(o),"isSelectingRangeEnd",(function(){if(!o.isInSelectingRange())return !1;var e=o.props,t=e.day,r=e.selectingDate,n=e.endDate;return Ne(t,e.selectsEnd?r:n)})),se(ue(o),"isRangeStart",(function(){var e=o.props,t=e.day,r=e.startDate,n=e.endDate;return !(!r||!n)&&Ne(r,t)})),se(ue(o),"isRangeEnd",(function(){var e=o.props,t=e.day,r=e.startDate,n=e.endDate;return !(!r||!n)&&Ne(n,t)})),se(ue(o),"isWeekend",(function(){var e=getDay(o.props.day);return 0===e||6===e})),se(ue(o),"isOutsideMonth",(function(){return void 0!==o.props.month&&o.props.month!==getMonth(o.props.day)})),se(ue(o),"getClassNames",(function(e){var r,n=o.props.dayClassName?o.props.dayClassName(e):void 0;return classnames("react-datepicker__day",n,"react-datepicker__day--"+ke(o.props.day,"ddd",r),{"react-datepicker__day--disabled":o.isDisabled(),"react-datepicker__day--excluded":o.isExcluded(),"react-datepicker__day--selected":o.isSameDay(o.props.selected),"react-datepicker__day--keyboard-selected":o.isKeyboardSelected(),"react-datepicker__day--range-start":o.isRangeStart(),"react-datepicker__day--range-end":o.isRangeEnd(),"react-datepicker__day--in-range":o.isInRange(),"react-datepicker__day--in-selecting-range":o.isInSelectingRange(),"react-datepicker__day--selecting-range-start":o.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":o.isSelectingRangeEnd(),"react-datepicker__day--today":o.isSameDay(De()),"react-datepicker__day--weekend":o.isWeekend(),"react-datepicker__day--outside-month":o.isOutsideMonth()},o.getHighLightedClass("react-datepicker__day--highlighted"))})),se(ue(o),"getAriaLabel",(function(){var e=o.props,t=e.day,r=e.ariaLabelPrefixWhenEnabled,n=void 0===r?"Choose":r,a=e.ariaLabelPrefixWhenDisabled,s=void 0===a?"Not available":a,p=o.isDisabled()||o.isExcluded()?s:n;return "".concat(p," ").concat(ke(t,"PPPP"))})),se(ue(o),"getTabIndex",(function(e,t){var r=e||o.props.selected,n=t||o.props.preSelection;return o.isKeyboardSelected()||o.isSameDay(r)&&Ne(n,r)?0:-1})),se(ue(o),"render",(function(){return React__default.createElement("div",{ref:o.dayEl,className:o.getClassNames(o.props.day),onKeyDown:o.handleOnKeyDown,onClick:o.handleClick,onMouseEnter:o.handleMouseEnter,tabIndex:o.getTabIndex(),"aria-label":o.getAriaLabel(),role:"option","aria-disabled":o.isDisabled()},o.props.renderDayContents?o.props.renderDayContents(getDate(o.props.day),o.props.day):getDate(o.props.day))})),o}return ce(n,React__default.Component),ae(n,[{key:"componentDidMount",value:function(){0===this.getTabIndex()&&this.isSameDay(this.props.preSelection)&&(!document.activeElement||document.activeElement===document.body)&&this.dayEl.current.focus();}},{key:"componentDidUpdate",value:function(e){0===this.getTabIndex()&&this.isSameDay(this.props.preSelection)!==this.isSameDay(e.preSelection)&&!e.isInputFocused&&this.dayEl.current.focus();}}]),n}(),it=function(r){function n(){var e,t;ne(this,n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];return se(ue(t=he(this,(e=le(n)).call.apply(e,[this].concat(o)))),"handleClick",(function(e){t.props.onClick&&t.props.onClick(e);})),t}return ce(n,React__default.Component),ae(n,[{key:"render",value:function(){var r=this.props,n=r.weekNumber,o=r.ariaLabelPrefix,a=void 0===o?"week ":o,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!r.onClick};return React__default.createElement("div",{className:classnames(s),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},n)}}]),n}(),ct=function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(a)))),"handleDayClick",(function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t);})),se(ue(n),"handleDayMouseEnter",(function(e){n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e);})),se(ue(n),"handleWeekClick",(function(e,t,r){"function"==typeof n.props.onWeekSelect&&n.props.onWeekSelect(e,t,r),n.props.shouldCloseOnSelect&&n.props.setOpen(!1);})),se(ue(n),"formatWeekNumber",(function(e){return n.props.formatWeekNumber?n.props.formatWeekNumber(e):function(e,t){var r=t&&Ie(t)||Ye()&&Ie(Ye());return getWeek(e,r?{locale:r}:null)}(e,n.props.locale)})),se(ue(n),"renderDays",(function(){var t=Ce(n.props.day,n.props.locale),r=[],o=n.formatWeekNumber(t);if(n.props.showWeekNumber){var a=n.props.onWeekSelect?n.handleWeekClick.bind(ue(n),t,o):void 0;r.push(React__default.createElement(it,{key:"W",weekNumber:o,onClick:a,ariaLabelPrefix:n.props.ariaLabelPrefix}));}return r.concat([0,1,2,3,4,5,6].map((function(r){var o=addDays(t,r);return React__default.createElement(pt,{ariaLabelPrefixWhenEnabled:n.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:n.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,month:n.props.month,onClick:n.handleDayClick.bind(ue(n),o),onMouseEnter:n.handleDayMouseEnter.bind(ue(n),o),minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,includeDates:n.props.includeDates,inline:n.props.inline,highlightDates:n.props.highlightDates,selectingDate:n.props.selectingDate,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,dayClassName:n.props.dayClassName,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,handleOnKeyDown:n.props.handleOnKeyDown,isInputFocused:n.props.isInputFocused})})))})),n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:!0}}}]),r}(),lt=6,dt=function(r){function n(){var r,o;ne(this,n);for(var a=arguments.length,s=new Array(a),c=0;c<a;c++)s[c]=arguments[c];return se(ue(o=he(this,(r=le(n)).call.apply(r,[this].concat(s)))),"handleDayClick",(function(e,t){o.props.onDayClick&&o.props.onDayClick(e,t,o.props.orderInDisplay);})),se(ue(o),"handleDayMouseEnter",(function(e){o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e);})),se(ue(o),"handleMouseLeave",(function(){o.props.onMouseLeave&&o.props.onMouseLeave();})),se(ue(o),"isRangeStartMonth",(function(e){var t=o.props,r=t.day,n=t.startDate,a=t.endDate;return !(!n||!a)&&Me(setMonth(r,e),n)})),se(ue(o),"isRangeStartQuarter",(function(e){var t=o.props,r=t.day,n=t.startDate,a=t.endDate;return !(!n||!a)&&Ee(setQuarter(r,e),n)})),se(ue(o),"isRangeEndMonth",(function(e){var t=o.props,r=t.day,n=t.startDate,a=t.endDate;return !(!n||!a)&&Me(setMonth(r,e),a)})),se(ue(o),"isRangeEndQuarter",(function(e){var t=o.props,r=t.day,n=t.startDate,a=t.endDate;return !(!n||!a)&&Ee(setQuarter(r,e),a)})),se(ue(o),"isWeekInMonth",(function(e){var t=o.props.day,r=addDays(e,6);return Me(e,t)||Me(r,t)})),se(ue(o),"renderWeeks",(function(){for(var t=[],r=o.props.fixedHeight,n=Ce(_e(o.props.day),o.props.locale),a=0,s=!1;t.push(React__default.createElement(ct,{ariaLabelPrefix:o.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:o.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:o.props.disabledDayAriaLabelPrefix,key:a,day:n,month:getMonth(o.props.day),onDayClick:o.handleDayClick,onDayMouseEnter:o.handleDayMouseEnter,onWeekSelect:o.props.onWeekSelect,formatWeekNumber:o.props.formatWeekNumber,locale:o.props.locale,minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,includeDates:o.props.includeDates,inline:o.props.inline,highlightDates:o.props.highlightDates,selectingDate:o.props.selectingDate,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,showWeekNumber:o.props.showWeekNumbers,startDate:o.props.startDate,endDate:o.props.endDate,dayClassName:o.props.dayClassName,setOpen:o.props.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,renderDayContents:o.props.renderDayContents,handleOnKeyDown:o.props.handleOnKeyDown,isInputFocused:o.props.isInputFocused})),!s;){a++,n=addWeeks(n,1);var p=r&&a>=lt,c=!r&&!o.isWeekInMonth(n);if(p||c){if(!o.props.peekNextMonth)break;s=!0;}}return t})),se(ue(o),"onMonthClick",(function(e,t){o.handleDayClick(_e(setMonth(o.props.day,t)),e);})),se(ue(o),"onQuarterClick",(function(e,t){var r;o.handleDayClick((r=setQuarter(o.props.day,t),startOfQuarter(r)),e);})),se(ue(o),"getMonthClassNames",(function(e){var r=o.props,n=r.day,a=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return classnames("react-datepicker__month-text","react-datepicker__month-".concat(e),{"react-datepicker__month--disabled":(i||c)&&We(setMonth(n,e),o.props),"react-datepicker__month--selected":getMonth(n)===e&&getYear(n)===getYear(p),"react-datepicker__month--in-range":Ae(a,s,e,n),"react-datepicker__month--range-start":o.isRangeStartMonth(e),"react-datepicker__month--range-end":o.isRangeEndMonth(e)})})),se(ue(o),"getQuarterClassNames",(function(e){var r=o.props,n=r.day,a=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return classnames("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(i||c)&&Be(setQuarter(n,e),o.props),"react-datepicker__quarter--selected":getQuarter(n)===e&&getYear(n)===getYear(p),"react-datepicker__quarter--in-range":Re(a,s,e,n),"react-datepicker__quarter--range-start":o.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":o.isRangeEndQuarter(e)})})),se(ue(o),"renderMonths",(function(){return [[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map((function(t,r){return React__default.createElement("div",{className:"react-datepicker__month-wrapper",key:r},t.map((function(t,r){return React__default.createElement("div",{key:r,onClick:function(e){o.onMonthClick(e,t);},className:o.getMonthClassNames(t)},Le(t,o.props.locale))})))}))})),se(ue(o),"renderQuarters",(function(){return React__default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,r){return React__default.createElement("div",{key:r,onClick:function(e){o.onQuarterClick(e,t);},className:o.getQuarterClassNames(t)},(n=t,a=o.props.locale,ke(setQuarter(De(),n),"QQQ",a)));var n,a;})))})),se(ue(o),"getClassNames",(function(){var e=o.props,r=e.selectingDate,n=e.selectsStart,a=e.selectsEnd,s=e.showMonthYearPicker,p=e.showQuarterYearPicker;return classnames("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(n||a)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})})),o}return ce(n,React__default.Component),ae(n,[{key:"render",value:function(){var t=this.props,r=t.showMonthYearPicker,n=t.showQuarterYearPicker,o=t.day,a=t.ariaLabelPrefix,s=void 0===a?"month ":a;return React__default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox","aria-label":"".concat(s," ").concat(ke(o,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),n}(),ut=function(t){function r(){var t,n;ne(this,r);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return se(ue(n=he(this,(t=le(r)).call.apply(t,[this].concat(s)))),"state",{height:null}),se(ue(n),"handleClick",(function(e){(n.props.minTime||n.props.maxTime)&&He(e,n.props)||n.props.excludeTimes&&Ke(e,n.props.excludeTimes)||n.props.includeTimes&&!Ke(e,n.props.includeTimes)||n.props.onChange(e);})),se(ue(n),"liClasses",(function(e,t,r){var o=["react-datepicker__time-list-item",n.props.timeClassName?n.props.timeClassName(e,t,r):void 0];return n.props.selected&&t===getHours(e)&&r===getMinutes(e)&&o.push("react-datepicker__time-list-item--selected"),((n.props.minTime||n.props.maxTime)&&He(e,n.props)||n.props.excludeTimes&&Ke(e,n.props.excludeTimes)||n.props.includeTimes&&!Ke(e,n.props.includeTimes))&&o.push("react-datepicker__time-list-item--disabled"),n.props.injectTimes&&(60*getHours(e)+getMinutes(e))%n.props.intervals!=0&&o.push("react-datepicker__time-list-item--injected"),o.join(" ")})),se(ue(n),"renderTimes",(function(){for(var t,r=[],o=n.props.format?n.props.format:"p",s=n.props.intervals,p=n.props.selected||n.props.openToDate||De(),i=getHours(p),c=getMinutes(p),l=(t=De(),startOfDay(t)),d=1440/s,u=n.props.injectTimes&&n.props.injectTimes.sort((function(e,t){return e-t})),h=0;h<d;h++){var m=addMinutes(l,h*s);if(r.push(m),u){var f=Je(l,m,h,s,u);r=r.concat(f);}}return r.map((function(t,r){return React__default.createElement("li",{key:r,onClick:n.handleClick.bind(ue(n),t),className:n.liClasses(t,i,c),ref:function(e){i===getHours(t)&&c>=getMinutes(t)&&(n.centerLi=e);}},ke(t,o,n.props.locale))}))})),n}return ce(r,React__default.Component),ae(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var t=this,r=this.state.height;return React__default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(e){t.header=e;}},React__default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),React__default.createElement("div",{className:"react-datepicker__time"},React__default.createElement("div",{className:"react-datepicker__time-box"},React__default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){t.list=e;},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}();se(ut,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var ht=function(t){function r(t){var n;return ne(this,r),se(ue(n=he(this,le(r).call(this,t))),"onTimeChange",(function(e){n.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),n.props.onChange(t);})),se(ue(n),"renderTimeInput",(function(){var t=n.state.time,r=n.props,o=r.timeString,a=r.customTimeInput;return a?React__default.cloneElement(a,{value:t,onChange:n.onTimeChange}):React__default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:t,onChange:function(e){n.onTimeChange(e.target.value||o);}})})),n.state={time:n.props.timeString},n}return ce(r,React__default.Component),ae(r,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__input-time-container"},React__default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),React__default.createElement("div",{className:"react-datepicker-time__input-container"},React__default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}]),r}();function mt(t){var r=t.className,n=t.children,o=t.showPopperArrow,a=t.arrowProps,s=void 0===a?{}:a;return React__default.createElement("div",{className:r},o&&React__default.createElement("div",pe({className:"react-datepicker__triangle"},s)),n)}var ft=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],vt=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return ft.some((function(e){return t.indexOf(e)>=0}))},yt=function(r){function n(t){var r;return ne(this,n),se(ue(r=he(this,le(n).call(this,t))),"handleClickOutside",(function(e){r.props.onClickOutside(e);})),se(ue(r),"setClickOutsideRef",(function(){return r.containerRef.current})),se(ue(r),"handleDropdownFocus",(function(e){vt(e.target)&&r.props.onDropdownFocus();})),se(ue(r),"getDateInView",(function(){var e=r.props,t=e.preSelection,n=e.selected,o=e.openToDate,a=$e(r.props),s=ze(r.props),p=De(),i=o||n||t;return i||(a&&isBefore(p,a)?a:s&&isAfter(p,s)?s:p)})),se(ue(r),"increaseMonth",(function(){r.setState((function(e){var t=e.date;return {date:addMonths(t,1)}}),(function(){return r.handleMonthChange(r.state.date)}));})),se(ue(r),"decreaseMonth",(function(){r.setState((function(e){var t=e.date;return {date:subMonths(t,1)}}),(function(){return r.handleMonthChange(r.state.date)}));})),se(ue(r),"handleDayClick",(function(e,t,n){return r.props.onSelect(e,t,n)})),se(ue(r),"handleDayMouseEnter",(function(e){r.setState({selectingDate:e}),r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e);})),se(ue(r),"handleMonthMouseLeave",(function(){r.setState({selectingDate:null}),r.props.onMonthMouseLeave&&r.props.onMonthMouseLeave();})),se(ue(r),"handleYearChange",(function(e){r.props.onYearChange&&r.props.onYearChange(e);})),se(ue(r),"handleMonthChange",(function(e){r.props.onMonthChange&&r.props.onMonthChange(e),r.props.adjustDateOnChange&&(r.props.onSelect&&r.props.onSelect(e),r.props.setOpen&&r.props.setOpen(!0));})),se(ue(r),"handleMonthYearChange",(function(e){r.handleYearChange(e),r.handleMonthChange(e);})),se(ue(r),"changeYear",(function(e){r.setState((function(t){var r=t.date;return {date:setYear(r,e)}}),(function(){return r.handleYearChange(r.state.date)}));})),se(ue(r),"changeMonth",(function(e){r.setState((function(t){var r=t.date;return {date:setMonth(r,e)}}),(function(){return r.handleMonthChange(r.state.date)}));})),se(ue(r),"changeMonthYear",(function(e){r.setState((function(t){var r=t.date;return {date:setYear(setMonth(r,getMonth(e)),getYear(e))}}),(function(){return r.handleMonthYearChange(r.state.date)}));})),se(ue(r),"header",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:r.state.date,n=Ce(t,r.props.locale),o=[];return r.props.showWeekNumbers&&o.push(React__default.createElement("div",{key:"W",className:"react-datepicker__day-name"},r.props.weekLabel||"#")),o.concat([0,1,2,3,4,5,6].map((function(t){var o=addDays(n,t),a=r.formatWeekday(o,r.props.locale);return React__default.createElement("div",{key:t,className:"react-datepicker__day-name"},a)})))})),se(ue(r),"formatWeekday",(function(e,t){return r.props.formatWeekDay?function(e,t,r){return t(ke(e,"EEEE",r))}(e,r.props.formatWeekDay,t):r.props.useWeekdaysShort?function(e,t){return ke(e,"EEE",t)}(e,t):function(e,t){return ke(e,"EEEEEE",t)}(e,t)})),se(ue(r),"decreaseYear",(function(){r.setState((function(e){var t=e.date;return {date:subYears(t,1)}}),(function(){return r.handleYearChange(r.state.date)}));})),se(ue(r),"renderPreviousButton",(function(){if(!r.props.renderCustomHeader){var t=r.props.showMonthYearPicker?qe(r.state.date,r.props):Qe(r.state.date,r.props);if((r.props.forceShowMonthNavigation||r.props.showDisabledMonthNavigation||!t)&&!r.props.showTimeSelectOnly){var n=["react-datepicker__navigation","react-datepicker__navigation--previous"],o=r.decreaseMonth;(r.props.showMonthYearPicker||r.props.showQuarterYearPicker)&&(o=r.decreaseYear),t&&r.props.showDisabledMonthNavigation&&(n.push("react-datepicker__navigation--previous--disabled"),o=null);var a=r.props.showMonthYearPicker||r.props.showQuarterYearPicker,s=r.props,p=s.previousMonthAriaLabel,i=void 0===p?"Previous Month":p,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return React__default.createElement("button",{type:"button",className:n.join(" "),onClick:o,"aria-label":a?l:i},a?r.props.previousYearButtonLabel:r.props.previousMonthButtonLabel)}}})),se(ue(r),"increaseYear",(function(){r.setState((function(e){var t=e.date;return {date:addYears(t,1)}}),(function(){return r.handleYearChange(r.state.date)}));})),se(ue(r),"renderNextButton",(function(){if(!r.props.renderCustomHeader){var t=r.props.showMonthYearPicker?Ue(r.state.date,r.props):Ve(r.state.date,r.props);if((r.props.forceShowMonthNavigation||r.props.showDisabledMonthNavigation||!t)&&!r.props.showTimeSelectOnly){var n=["react-datepicker__navigation","react-datepicker__navigation--next"];r.props.showTimeSelect&&n.push("react-datepicker__navigation--next--with-time"),r.props.todayButton&&n.push("react-datepicker__navigation--next--with-today-button");var o=r.increaseMonth;(r.props.showMonthYearPicker||r.props.showQuarterYearPicker)&&(o=r.increaseYear),t&&r.props.showDisabledMonthNavigation&&(n.push("react-datepicker__navigation--next--disabled"),o=null);var a=r.props.showMonthYearPicker||r.props.showQuarterYearPicker,s=r.props,p=s.nextMonthAriaLabel,i=void 0===p?"Next Month":p,c=s.nextYearAriaLabel,l=void 0===c?"Next Year":c;return React__default.createElement("button",{type:"button",className:n.join(" "),onClick:o,"aria-label":a?l:i},a?r.props.nextYearButtonLabel:r.props.nextMonthButtonLabel)}}})),se(ue(r),"renderCurrentMonth",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:r.state.date,n=["react-datepicker__current-month"];return r.props.showYearDropdown&&n.push("react-datepicker__current-month--hasYearDropdown"),r.props.showMonthDropdown&&n.push("react-datepicker__current-month--hasMonthDropdown"),r.props.showMonthYearDropdown&&n.push("react-datepicker__current-month--hasMonthYearDropdown"),React__default.createElement("div",{className:n.join(" ")},ke(t,r.props.dateFormat,r.props.locale))})),se(ue(r),"renderYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showYearDropdown&&!t)return React__default.createElement(tt,{adjustDateOnChange:r.props.adjustDateOnChange,date:r.state.date,onSelect:r.props.onSelect,setOpen:r.props.setOpen,dropdownMode:r.props.dropdownMode,onChange:r.changeYear,minDate:r.props.minDate,maxDate:r.props.maxDate,year:getYear(r.state.date),scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})})),se(ue(r),"renderMonthDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showMonthDropdown&&!t)return React__default.createElement(nt,{dropdownMode:r.props.dropdownMode,locale:r.props.locale,onChange:r.changeMonth,month:getMonth(r.state.date),useShortMonthInDropdown:r.props.useShortMonthInDropdown})})),se(ue(r),"renderMonthYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(r.props.showMonthYearDropdown&&!t)return React__default.createElement(st,{dropdownMode:r.props.dropdownMode,locale:r.props.locale,dateFormat:r.props.dateFormat,onChange:r.changeMonthYear,minDate:r.props.minDate,maxDate:r.props.maxDate,date:r.state.date,scrollableMonthYearDropdown:r.props.scrollableMonthYearDropdown})})),se(ue(r),"renderTodayButton",(function(){if(r.props.todayButton&&!r.props.showTimeSelectOnly)return React__default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return r.props.onSelect(startOfDay(De()),e)}},r.props.todayButton)})),se(ue(r),"renderDefaultHeader",(function(t){var n=t.monthDate,o=t.i;return React__default.createElement("div",{className:"react-datepicker__header"},r.renderCurrentMonth(n),React__default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),onFocus:r.handleDropdownFocus},r.renderMonthDropdown(0!==o),r.renderMonthYearDropdown(0!==o),r.renderYearDropdown(0!==o)),React__default.createElement("div",{className:"react-datepicker__day-names"},r.header(n)))})),se(ue(r),"renderCustomHeader",(function(t){var n=t.monthDate;if(0!==t.i)return null;var o=Qe(r.state.date,r.props),a=Ve(r.state.date,r.props),s=qe(r.state.date,r.props),p=Ue(r.state.date,r.props);return React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:r.props.onDropdownFocus},r.props.renderCustomHeader(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?ie(Object(r),!0).forEach((function(t){se(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):ie(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}({},r.state,{changeMonth:r.changeMonth,changeYear:r.changeYear,decreaseMonth:r.decreaseMonth,increaseMonth:r.increaseMonth,decreaseYear:r.decreaseYear,increaseYear:r.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:a,prevYearButtonDisabled:s,nextYearButtonDisabled:p})),React__default.createElement("div",{className:"react-datepicker__day-names"},r.header(n)))})),se(ue(r),"renderYearHeader",(function(){return React__default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},getYear(r.state.date))})),se(ue(r),"renderHeader",(function(e){switch(!0){case void 0!==r.props.renderCustomHeader:return r.renderCustomHeader(e);case r.props.showMonthYearPicker||r.props.showQuarterYearPicker:return r.renderYearHeader(e);default:return r.renderDefaultHeader(e)}})),se(ue(r),"renderMonths",(function(){if(!r.props.showTimeSelectOnly){for(var t=[],n=r.props.showPreviousMonths?r.props.monthsShown-1:0,o=subMonths(r.state.date,n),a=0;a<r.props.monthsShown;++a){var s=a-r.props.monthSelectedIn,p=addMonths(o,s),i="month-".concat(a);t.push(React__default.createElement("div",{key:i,ref:function(e){r.monthContainer=e;},className:"react-datepicker__month-container"},r.renderHeader({monthDate:p,i:a}),React__default.createElement(dt,{chooseDayAriaLabelPrefix:r.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:r.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:r.props.weekAriaLabelPrefix,onChange:r.changeMonthYear,day:p,dayClassName:r.props.dayClassName,monthClassName:r.props.monthClassName,onDayClick:r.handleDayClick,handleOnKeyDown:r.props.handleOnKeyDown,onDayMouseEnter:r.handleDayMouseEnter,onMouseLeave:r.handleMonthMouseLeave,onWeekSelect:r.props.onWeekSelect,orderInDisplay:a,formatWeekNumber:r.props.formatWeekNumber,locale:r.props.locale,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,highlightDates:r.props.highlightDates,selectingDate:r.state.selectingDate,includeDates:r.props.includeDates,inline:r.props.inline,fixedHeight:r.props.fixedHeight,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumbers:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,peekNextMonth:r.props.peekNextMonth,setOpen:r.props.setOpen,shouldCloseOnSelect:r.props.shouldCloseOnSelect,renderDayContents:r.props.renderDayContents,disabledKeyboardNavigation:r.props.disabledKeyboardNavigation,showMonthYearPicker:r.props.showMonthYearPicker,showQuarterYearPicker:r.props.showQuarterYearPicker,isInputFocused:r.props.isInputFocused})));}return t}})),se(ue(r),"renderTimeSection",(function(){if(r.props.showTimeSelect&&(r.state.monthContainer||r.props.showTimeSelectOnly))return React__default.createElement(ut,{selected:r.props.selected,openToDate:r.props.openToDate,onChange:r.props.onTimeChange,timeClassName:r.props.timeClassName,format:r.props.timeFormat,includeTimes:r.props.includeTimes,intervals:r.props.timeIntervals,minTime:r.props.minTime,maxTime:r.props.maxTime,excludeTimes:r.props.excludeTimes,timeCaption:r.props.timeCaption,todayButton:r.props.todayButton,showMonthDropdown:r.props.showMonthDropdown,showMonthYearDropdown:r.props.showMonthYearDropdown,showYearDropdown:r.props.showYearDropdown,withPortal:r.props.withPortal,monthRef:r.state.monthContainer,injectTimes:r.props.injectTimes,locale:r.props.locale})})),se(ue(r),"renderInputTimeSection",(function(){var t=new Date(r.props.selected),n="".concat(Xe(t.getHours()),":").concat(Xe(t.getMinutes()));if(r.props.showTimeInput)return React__default.createElement(ht,{timeString:n,timeInputLabel:r.props.timeInputLabel,onChange:r.props.onTimeChange,customTimeInput:r.props.customTimeInput})})),r.containerRef=React__default.createRef(),r.state={date:r.getDateInView(),selectingDate:null,monthContainer:null},r}return ce(n,React__default.Component),ae(n,null,[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null}}}]),ae(n,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ne(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ne(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});}},{key:"render",value:function(){var r=this.props.container||mt;return React__default.createElement("div",{ref:this.containerRef},React__default.createElement(r,{className:classnames("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),n}(),Dt="[tabindex], a, button, input, select, textarea",gt=function(e){return !e.disabled&&-1!==e.tabIndex},wt=function(t){function r(t){var n;return ne(this,r),se(ue(n=he(this,le(r).call(this,t))),"getTabChildren",(function(){return Array.prototype.slice.call(n.tabLoopRef.current.querySelectorAll(Dt),1,-1).filter(gt)})),se(ue(n),"handleFocusStart",(function(e){var t=n.getTabChildren();t&&t.length>1&&t[t.length-1].focus();})),se(ue(n),"handleFocusEnd",(function(e){var t=n.getTabChildren();t&&t.length>1&&t[0].focus();})),n.tabLoopRef=React__default.createRef(),n}return ce(r,React__default.Component),ae(r,null,[{key:"defaultProps",get:function(){return {enableTabLoop:!0}}}]),ae(r,[{key:"render",value:function(){return this.props.enableTabLoop?React__default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},React__default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,React__default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}]),r}(),kt=function(r){function n(){return ne(this,n),he(this,le(n).apply(this,arguments))}return ce(n,React__default.Component),ae(n,[{key:"render",value:function(){var r,n=this.props,o=n.className,a=n.wrapperClassName,s=n.hidePopper,p=n.popperComponent,i=n.popperModifiers,c=n.popperPlacement,l=n.popperProps,d=n.targetComponent,u=n.enableTabLoop,h=n.popperOnKeyDown;if(!s){var m=classnames("react-datepicker-popper",o);r=React__default.createElement(Popper$1,pe({modifiers:i,placement:c},l),(function(t){var r=t.ref,n=t.style,o=t.placement,a=t.arrowProps;return React__default.createElement(wt,{enableTabLoop:u},React__default.createElement("div",pe({ref:r,style:n},{className:m,"data-placement":o,onKeyDown:h}),React__default.cloneElement(p,{arrowProps:a})))}));}this.props.popperContainer&&(r=React__default.createElement(this.props.popperContainer,{},r));var f=classnames("react-datepicker-wrapper",a);return React__default.createElement(Manager,{className:"react-datepicker-manager"},React__default.createElement(Reference,null,(function(t){var r=t.ref;return React__default.createElement("div",{ref:r,className:f},d)})),r)}}],[{key:"defaultProps",get:function(){return {hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),n}(),bt="react-datepicker-ignore-onclickoutside",Ct=onClickOutsideHOC(yt);var _t="Date input not valid.",St=function(n){function o(n){var a;return ne(this,o),se(ue(a=he(this,le(o).call(this,n))),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:De()})),se(ue(a),"calcInitialState",(function(){var e=a.getPreSelection(),t=$e(a.props),r=ze(a.props),n=t&&isBefore(e,t)?t:r&&isAfter(e,r)?r:e;return {open:a.props.startOpen||!1,preventFocus:!1,preSelection:a.props.selected?a.props.selected:n,highlightDates:Ge(a.props.highlightDates),focused:!1}})),se(ue(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout);})),se(ue(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus();})),se(ue(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput();})),se(ue(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Et},(function(){e||a.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null});}));}));})),se(ue(a),"inputOk",(function(){return isDate(a.state.preSelection)})),se(ue(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),se(ue(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0});})),se(ue(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null;})),se(ue(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1);})),se(ue(a),"handleDropdownFocus",(function(){a.cancelFocusInput();})),se(ue(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1});})),se(ue(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault();})),se(ue(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(ue(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Mt});var o=ge(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing);!o&&n.target.value||a.setSelected(o,n,!0);}})),se(ue(a),"handleSelect",(function(e,t,r){a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.setSelected(e,t,void 0,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect?a.setPreSelection(e):a.props.inline||a.setOpen(!1);})),se(ue(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!Fe(o,a.props)){if(!Pe(a.props.selected,o)||a.props.allowSameDay){if(null!==o){if(a.props.selected){var s=a.props.selected;r&&(s=De(o)),o=be(o,{hour:getHours(s),minute:getMinutes(s),second:getSeconds(s)});}a.props.inline||a.setState({preSelection:o}),a.props.inline&&a.props.monthsShown>1&&!a.props.inlineFocusSelectedMonth&&a.setState({monthSelectedIn:n});}a.props.onChange(o,t);}a.props.onSelect(o,t),r||a.setState({inputValue:null});}})),se(ue(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;e&&(t&&r?n=xe(e,a.props.minDate,a.props.maxDate):t?n=isAfter(e,a.props.minDate):r&&(n=isBefore(e,a.props.maxDate))),n&&a.setState({preSelection:e});})),se(ue(a),"handleTimeChange",(function(e){var t=be(a.props.selected?a.props.selected:a.getPreSelection(),{hour:getHours(e),minute:getMinutes(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null});})),se(ue(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick();})),se(ue(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus())}var n=De(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Et?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:_t});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick();})),se(ue(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=De(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:_t});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=subDays(r,1);break;case"ArrowRight":n=addDays(r,1);break;case"ArrowUp":n=subWeeks(r,1);break;case"ArrowDown":n=addWeeks(r,1);break;case"PageUp":n=subMonths(r,1);break;case"PageDown":n=addMonths(r,1);break;case"Home":n=subYears(r,1);break;case"End":n=addYears(r,1);}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:_t}));e.preventDefault(),a.setState({lastPreSelectChange:Et}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n);}})),se(ue(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout(a.setFocus);})));})),se(ue(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.onChange(null,e),a.setState({inputValue:null});})),se(ue(a),"clear",(function(){a.onClearClick();})),se(ue(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?React__default.createElement(Ct,{ref:function(e){a.calendar=e;},locale:a.props.locale,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:bt,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput},a.props.children):null})),se(ue(a),"renderDateInput",(function(){var r,n,o,s,p,i=classnames(a.props.className,se({},bt,a.state.open)),c=a.props.customInput||React__default.createElement("input",{type:"text"}),l=a.props.customInputRef||"ref",d="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:(n=a.props.selected,o=a.props,s=o.dateFormat,p=o.locale,n&&ke(n,Array.isArray(s)?s[0]:s,p)||"");return React__default.cloneElement(c,(se(r={},l,(function(e){a.input=e;})),se(r,"value",d),se(r,"onBlur",a.handleBlur),se(r,"onChange",a.handleChange),se(r,"onClick",a.onInputClick),se(r,"onFocus",a.handleFocus),se(r,"onKeyDown",a.onInputKeyDown),se(r,"id",a.props.id),se(r,"name",a.props.name),se(r,"autoFocus",a.props.autoFocus),se(r,"placeholder",a.props.placeholderText),se(r,"disabled",a.props.disabled),se(r,"autoComplete",a.props.autoComplete),se(r,"className",classnames(c.props.className,i)),se(r,"title",a.props.title),se(r,"readOnly",a.props.readOnly),se(r,"required",a.props.required),se(r,"tabIndex",a.props.tabIndex),se(r,"aria-labelledby",a.props.ariaLabelledBy),r))})),se(ue(a),"renderClearButton",(function(){var t=a.props,r=t.isClearable,n=t.selected,o=t.clearButtonTitle,s=t.ariaLabelClose,p=void 0===s?"Close":s;return r&&null!=n?React__default.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":p,onClick:a.onClearClick,title:o,tabIndex:-1}):null})),a.state=a.calcInitialState(),a}return ce(o,React__default.Component),ae(o,null,[{key:"defaultProps",get:function(){return {allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),ae(o,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?getMonth(r)!==getMonth(n)||getYear(r)!==getYear(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Ge(this.props.highlightDates)}),t.focused||Pe(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout();}},{key:"render",value:function(){var t=this.renderCalendar();return this.props.inline&&!this.props.withPortal?t:this.props.withPortal?React__default.createElement("div",null,this.props.inline?null:React__default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?React__default.createElement("div",{className:"react-datepicker__portal"},t):null):React__default.createElement(kt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:React__default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:t,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}]),o}(),Mt="input",Et="navigate";

/* loaded by smart-asset */
require("../src/components/DatePicker/DatePicker.scss");

var _jsxFileName$c = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/DatePicker/DatePicker.js";
class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.onFocus = e => {
      const {
        onFocusInput
      } = this.props;
      this.setState({
        inputFocus: 'active'
      });
      const {
        target
      } = e;
      const {
        id
      } = target;
      if (onFocusInput) onFocusInput(id);
    };

    this.onBlur = () => {
      if (this.datepicker.input.value) this.setState({
        inputFocus: 'hasvalue'
      });else if (!this.datepicker.input.value) {
        this.setState({
          inputFocus: ''
        });
      }
    };

    this.datepickerLabelClick = () => {
      this.setState({
        inputFocus: 'active'
      }); // this.datepicker.input.focus();
    };

    this.handleSelect = date => {
      const {
        id,
        onChange,
        validationChange,
        required
      } = this.props;

      if (required) {
        const validation = false;
        validationChange(id, validation);
      }

      onChange(id, date);
    };

    this.onDatepickerRef = el => {
      if (el && el.input) {
        el.input.readOnly = true;
      }
    };

    this.state = {
      value: ''
    }; // this.inputRef = React.createRef();
  }

  componentDidMount() {
    const {
      value,
      currentFieldFocus,
      id
    } = this.props;

    if (value && currentFieldFocus !== id) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }

    if (!value) {
      this.setState({
        inputFocus: ''
      });
    }

    this.setState({
      value
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      value,
      currentFieldFocus,
      id
    } = nextProps;

    if (currentFieldFocus === id) {
      // this.datepicker.input.focus();
      this.setState({
        inputFocus: 'active'
      });
    }

    if (value && currentFieldFocus !== id) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }

    if (!value) {
      this.setState({
        inputFocus: ''
      });
    }

    this.setState({
      value
    });
  }

  render() {
    const {
      value,
      inputFocus
    } = this.state;
    const {
      validation,
      label,
      maxDate,
      dateFormat,
      showMonthYearPicker
    } = this.props;
    const validationClassName = validation && 'error';
    const dom = /*#__PURE__*/React__default.createElement("div", {
      className: `datepicker ${inputFocus} ${validationClassName}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$c,
        lineNumber: 94,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "datepicker-label",
      role: "presentation",
      onClick: () => this.datepickerLabelClick(),
      __self: this,
      __source: {
        fileName: _jsxFileName$c,
        lineNumber: 95,
        columnNumber: 9
      }
    }, label), /*#__PURE__*/React__default.createElement(St, {
      selected: value,
      onFocus: this.onFocus,
      showYearDropdown: true,
      onSelect: this.handleSelect,
      onChange: this.onChange,
      maxDate: maxDate,
      dateFormat: dateFormat,
      showMonthYearPicker: showMonthYearPicker // ref={datepicker => { this.datepicker = datepicker }}
      ,
      ref: el => this.onDatepickerRef(el),
      __self: this,
      __source: {
        fileName: _jsxFileName$c,
        lineNumber: 102,
        columnNumber: 9
      }
    }));
    return dom;
  }

}
DatePicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  currentFieldFocus: PropTypes.string,
  dateFormat: PropTypes.string,
  validation: PropTypes.bool,
  onFocusInput: PropTypes.func,
  onChange: PropTypes.func,
  validationChange: PropTypes.func,
  showMonthYearPicker: PropTypes.bool
};
DatePicker.defaultProps = {
  id: '',
  label: '',
  currentFieldFocus: '',
  dateFormat: '',
  validation: false,
  showMonthYearPicker: false,
  onFocusInput: () => {},
  onChange: () => {},
  validationChange: () => {}
};

/* loaded by smart-asset */
require("../src/components/FilterDropdown/FilterDropdown.scss");

var _jsxFileName$d = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/FilterDropdown/FilterDropdown.js";
class FilterDropdown extends Component {
  constructor(props) {
    super(props);

    this.showDropdown = () => {
      const {
        showDropdown
      } = this.state;
      this.setState({
        showDropdown: !showDropdown
      });
    };

    this.listClickHandler = (key, value) => {
      const {
        showDropdown
      } = this.state;
      const {
        onClick,
        multiple
      } = this.props;

      if (!multiple) {
        this.setState({
          showDropdown: !showDropdown
        });
        onClick(key, value);
      } else {
        const {
          filterMultiSelectHandler
        } = this.props;
        filterMultiSelectHandler(key);
      }
    };

    this.applyMultipleClick = () => {
      const {
        showDropdown
      } = this.state;
      const {
        onClick
      } = this.props;
      this.setState({
        showDropdown: !showDropdown
      });
      onClick();
    };

    this.state = {
      showDropdown: false
    };
  }

  render() {
    const {
      data,
      filterActiveValue,
      color,
      multiple,
      multipleData
    } = this.props;
    const {
      showDropdown
    } = this.state;
    const listDom = data.map(item => {
      return /*#__PURE__*/React__default.createElement("li", {
        key: `${item.key}`,
        className: "filterDropdown__list_item ",
        role: "presentation",
        onClick: () => this.listClickHandler(item.key, item.displayName),
        __self: this,
        __source: {
          fileName: _jsxFileName$d,
          lineNumber: 51,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "filterDropdown__list_item_text",
        __self: this,
        __source: {
          fileName: _jsxFileName$d,
          lineNumber: 57,
          columnNumber: 11
        }
      }, item.displayName), multipleData && multipleData[item.key] ? /*#__PURE__*/React__default.createElement("div", {
        className: "checkmark",
        __self: this,
        __source: {
          fileName: _jsxFileName$d,
          lineNumber: 61,
          columnNumber: 13
        }
      }) : '', /*#__PURE__*/React__default.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName$d,
          lineNumber: 65,
          columnNumber: 11
        }
      }));
    });
    const Dom = /*#__PURE__*/React__default.createElement("div", {
      className: "filterDropdown",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 70,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: `filterDropdown__value ${color}`,
      role: "presentation",
      onClick: () => this.showDropdown(),
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 71,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "filterDropdown__value_text",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 76,
        columnNumber: 11
      }
    }, !filterActiveValue ? 'FILTER BY' : filterActiveValue), /*#__PURE__*/React__default.createElement("div", {
      className: "filterDropdown__value_img",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 79,
        columnNumber: 11
      }
    }, color === 'blue' ? /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 81,
        columnNumber: 15
      }
    }, '<') : /*#__PURE__*/React__default.createElement("img", {
      src: DownArrowSvg,
      alt: "down",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 83,
        columnNumber: 15
      }
    }))), showDropdown && /*#__PURE__*/React__default.createElement("div", {
      className: "filterDropdown__list_wrapper",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 88,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement("ul", {
      className: "u_list_style_none filterDropdown__list",
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 89,
        columnNumber: 13
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 90,
        columnNumber: 15
      }
    }), listDom), multiple ? /*#__PURE__*/React__default.createElement(Button, {
      text: "apply",
      onClick: () => this.applyMultipleClick(),
      __self: this,
      __source: {
        fileName: _jsxFileName$d,
        lineNumber: 94,
        columnNumber: 15
      }
    }) : ''));
    return Dom;
  }

}
FilterDropdown.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    displayName: PropTypes.string,
    index: PropTypes.number
  })),
  multiple: PropTypes.bool,
  onClick: PropTypes.func,
  filterActiveValue: PropTypes.string
};
FilterDropdown.defaultProps = {
  data: [],
  onClick: () => {},
  filterActiveValue: '',
  multiple: false
};

/* loaded by smart-asset */
require("../src/components/HeaderUserDetail/HeaderUserDetail.scss");

var _jsxFileName$e = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/HeaderUserDetail/HeaderUserDetail.js";
const HeaderUserDetail = ({
  userName,
  statusText
}) => {
  // const { t } = useTranslation()
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 11,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser_wrapper",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 12,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser__detail",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 13,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser__detail_name",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 14,
      columnNumber: 11
    }
  }, userName), statusText && /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser__detail_status",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 16,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "headeruser__detail_status_text",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 17,
      columnNumber: 15
    }
  }, statusText))), /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser_menu",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 23,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: SettingIcon,
    alt: "setting",
    className: "u_mobile_display_none",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 24,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "headeruser_menu_icon",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 29,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bar",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 30,
      columnNumber: 13
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bar",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 31,
      columnNumber: 13
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "bar",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 32,
      columnNumber: 13
    }
  })))));
  return Dom;
};
HeaderUserDetail.propTypes = {
  userName: PropTypes.string
};
HeaderUserDetail.defaultProps = {
  userName: ''
};

/* loaded by smart-asset */
require("../src/components/HomeChildrenListItem/HomeChildrenListItem.scss");

var _jsxFileName$f = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/HomeChildrenListItem/HomeChildrenListItem.js";
const HomeChildrenListItem = props => {
  const {
    t
  } = useTranslation();
  const {
    item,
    lunchOrderClick,
    childTopUpClick,
    nutritionClick,
    transactionHistoryClick
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 19,
      columnNumber: 5
    }
  }, (item.allow_classroom_delivery || item.allow_pre_prepared_meals) && /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 21,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 22,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label_sub",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 23,
      columnNumber: 13
    }
  }, t('lunch_order'))), /*#__PURE__*/React__default.createElement(Button, {
    size: "small",
    text: t('order'),
    onClick: () => lunchOrderClick(item),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 27,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 34,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 35,
      columnNumber: 9
    }
  }, t('current_balance'), ":", /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label_sub",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 37,
      columnNumber: 11
    }
  }, `${LocalStorage.getCurrency()} ${item && item.balance}`)), /*#__PURE__*/React__default.createElement(Button, {
    size: "small",
    text: t('top_up'),
    onClick: () => childTopUpClick(item),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 41,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 61,
      columnNumber: 9
    }
  }, t('nutrition_report'), ":", /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label_sub",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 63,
      columnNumber: 11
    }
  }, t('yacob_score'), ": TBD")), /*#__PURE__*/React__default.createElement(Button, {
    size: "small",
    text: t('more'),
    onClick: () => nutritionClick(item),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 67,
      columnNumber: 9
    }
  })), !item.allow_classroom_delivery && /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 74,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "home_childrenlist_item_label",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 75,
      columnNumber: 11
    }
  }, t('transactions')), /*#__PURE__*/React__default.createElement(Button, {
    color: "lightgrey",
    size: "small",
    text: t('more'),
    onClick: () => transactionHistoryClick(item),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$f,
      lineNumber: 78,
      columnNumber: 11
    }
  })));
  return Dom;
};
HomeChildrenListItem.propTypes = {
  lunchOrderClick: PropTypes.func,
  childTopUpClick: PropTypes.func,
  nutritionClick: PropTypes.func,
  transactionHistoryClick: PropTypes.func,
  item: PropTypes.shape({})
};
HomeChildrenListItem.defaultProps = {
  lunchOrderClick: () => {},
  childTopUpClick: () => {},
  nutritionClick: () => {},
  transactionHistoryClick: () => {},
  item: {}
};

/* loaded by smart-asset */
require("../src/components/InputLabelFloat/InputLabelFloat.scss");

function EmailValidation(data) {
  data = data.trim();
  const re = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return re.test(data);
}
function PhoneNumberValidation(data) {
  const re = /^[a-zA-Z0-9\-().\s]{10,15}$/;
  return re.test(data);
}
function PasswordValidation(password) {
  // min 8 char, one digit, one lowercase, one uppercase, special char as optional
  const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%*#?&]{8,}$/;
  return re.test(password);
}
function NumberValidation(value) {
  value = value.trim();
  const reg = /^[0-9]+$/;
  if (!value) return true;
  return reg.test(value);
}
function HasValueValidation(data) {
  data = data.trim();
  return data;
}

/* loaded by smart-asset */
var alertIcon = require("../src/assets/alert.png");

var _jsxFileName$g = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/InputLabelFloat/InputLabelFloat.js";
class InputLabelFloat extends Component {
  constructor(props) {
    super(props);

    this.onFocus = () => {
      this.inputRef.current.focus();
      this.setState({
        inputFocus: 'active'
      });
      const {
        onFocus,
        id
      } = this.props;
      if (onFocus) onFocus(id);
    };

    this.onBlur = () => {
      if (this.inputRef.current.value) this.setState({
        inputFocus: 'hasvalue'
      });else if (!this.inputRef.current.value) {
        this.setState({
          inputFocus: ''
        });
      }
    };

    this.onChange = e => {
      const {
        onChange,
        validationChange,
        required,
        number
      } = this.props;
      let numberValidation = true;

      if (number && e.target.value) {
        e.target.value = e.target.value.trim();
        numberValidation = NumberValidation(e.target.value);
      }

      if (numberValidation && e.target.value.length <= 50) {
        onChange(e);
      } else if (e.target.value.length > 50) {
        alert('Exceeds maximum character limit of 50');
      }

      if (required) {
        const validation = this.validate(e.target.value);
        validationChange(e.target.id, validation);
      }
    };

    this.validate = value => {
      const {
        type
      } = this.props;
      let validation;

      switch (type) {
        case 'email':
          validation = !EmailValidation(value);
          break;

        case 'number':
          validation = !NumberValidation(value);
          break;

        default:
          validation = false;
      }

      return validation;
    };

    this.state = {
      inputFocus: ''
    };
    this.inputRef = React__default.createRef();
  }

  componentDidMount() {
    const {
      id,
      currentFieldFocus,
      value
    } = this.props;

    if (id === currentFieldFocus) {
      this.setState({
        inputFocus: 'active'
      });
      this.inputRef.current.focus();
    } else if (value && id === currentFieldFocus) {
      this.setState({
        inputFocus: 'active'
      });
    } else if (value) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      id,
      currentFieldFocus,
      value
    } = nextProps;

    if (id === currentFieldFocus) {
      this.inputRef.current.focus();
      this.setState({
        inputFocus: 'active'
      });
    } else if (value && currentFieldFocus !== id) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    } else if (!value) {
      this.setState({
        inputFocus: ''
      });
    }
  }

  render() {
    const {
      inputFocus
    } = this.state;
    const {
      id,
      type,
      label,
      validation,
      value,
      disabled,
      textSelect,
      validationMessage
    } = this.props;
    const validationClassName = validation && 'error';
    const textSelectClassName = textSelect && 'textSelect';
    const DOM = /*#__PURE__*/React__default.createElement("div", {
      className: "inputfloatlabel_container",
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 105,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: `inputfloatlabel ${inputFocus} ${validationClassName} ${textSelectClassName}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 106,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("label", {
      htmlFor: id,
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 109,
        columnNumber: 11
      }
    }, label), /*#__PURE__*/React__default.createElement("input", {
      disabled: disabled,
      value: value,
      id: id,
      type: type,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      ref: this.inputRef,
      onChange: this.onChange,
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 110,
        columnNumber: 11
      }
    })), validation && validationMessage && /*#__PURE__*/React__default.createElement("div", {
      className: "inputfloatlabel_message",
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 122,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: alertIcon,
      alt: "alert",
      width: "20",
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 123,
        columnNumber: 13
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "inputfloatlabel_message_text",
      __self: this,
      __source: {
        fileName: _jsxFileName$g,
        lineNumber: 124,
        columnNumber: 13
      }
    }, validationMessage)));
    return DOM;
  }

}
InputLabelFloat.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.bool,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  validationChange: PropTypes.func,
  number: PropTypes.bool,
  disabled: PropTypes.bool,
  textSelect: PropTypes.bool,
  validationMessage: PropTypes.string
};
InputLabelFloat.defaultProps = {
  id: '',
  type: '',
  label: '',
  validation: false,
  textSelect: false,
  value: '',
  number: false,
  disabled: false,
  onFocus: () => {},
  onChange: () => {},
  validationChange: () => {},
  validationMessage: ''
};

/* loaded by smart-asset */
require("../src/components/InputMultipleValue/InputMultipleValue.scss");

/* loaded by smart-asset */
var EmailCloseIcon = require("../src/assets/email-close.svg");

var _jsxFileName$h = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/InputMultipleValue/InputMultipleValue.js";
class InputMultipleValue extends Component {
  constructor(props) {
    super(props);

    this.autosize = event => {
      event.preventDefault();

      if (event.target.value.indexOf(' ') > -1) {
        this.eamilList(event.target.value);
        return;
      }

      if (event.keyCode !== 13) {
        const int = Number(7) || 7.7;
        const width = (event.target.value.length + 10) * int;
        event.target.style.cssText = 'height:auto; padding:0';
        event.target.style.cssText = `height: ${event.target.scrollHeight}px;`;
        event.target.style.cssText = `width: ${width}px;`;
      }
    };

    this.eamilList = value => {
      const {
        listvalue
      } = this.state;
      const {
        getEmailAddressList
      } = this.props;

      if (EmailValidation(value)) {
        listvalue.push(value.trim());
        this.setState({
          listvalue,
          textareavalue: ''
        });
      }

      getEmailAddressList(listvalue);
    };

    this.onFocus = () => {
      this.inputRef.current.focus();
      this.setState({
        inputFocus: 'active'
      });
      const {
        onFocus,
        id
      } = this.props;
      if (onFocus) onFocus(id);
    };

    this.onBlur = () => {
      const {
        listvalue,
        textareavalue
      } = this.state;

      if (listvalue && listvalue.length || textareavalue) {
        this.setState({
          inputFocus: 'hasvalue'
        });
        if (textareavalue) this.eamilList(textareavalue);
      } else if (listvalue && !listvalue.length && !textareavalue) {
        this.setState({
          inputFocus: ''
        });
      }
    };

    this.onChange = e => {
      const {
        onChange,
        validationChange,
        required
      } = this.props;
      const {
        target
      } = e;
      const {
        value
      } = target;
      const {
        id
      } = target;
      this.setState({
        textareavalue: value.replace(/[\r\n\v]+/g, '')
      });
      onChange(id, value);

      if (required) {
        const validation = this.validate(value);
        validationChange(id, validation);
      }
    };

    this.validate = value => {
      const {
        type
      } = this.props;
      let validation;

      switch (type) {
        case 'email':
          validation = !EmailValidation(value);
          break;

        default:
          validation = false;
      }

      return validation;
    };

    this.removeListValue = index => {
      const {
        listvalue
      } = this.state;
      listvalue.splice(index, 1);
      this.setState({
        listvalue
      });
    };

    this.state = {
      inputFocus: '',
      textareavalue: '',
      listvalue: [],
      width: 100
    };
    this.inputRef = React__default.createRef();
  }

  componentDidMount() {
    const textarea = document.getElementsByClassName('textarea') && document.getElementsByClassName('textarea')[0];
    textarea.addEventListener('keyup', this.autosize);
  }

  componentWillReceiveProps(nextProps) {
    const {
      id,
      currentFieldFocus,
      value,
      emailaddressList
    } = nextProps;
    if (nextProps.id === nextProps.currentFieldFocus) this.inputRef.current.focus();

    if (value && id === currentFieldFocus) {
      this.setState({
        inputFocus: 'active'
      });
    } else if (value) {
      this.setState({
        inputFocus: 'hasvalue'
      });
    }

    if (emailaddressList) {
      this.setState({
        listvalue: emailaddressList
      });
    }
  }

  componentWillUnmount() {
    const textarea = document.getElementsByClassName('textarea') && document.getElementsByClassName('textarea')[0];
    textarea.removeEventListener('keyup', this.autosize);
  }

  render() {
    const {
      inputFocus,
      textareavalue,
      listvalue,
      width
    } = this.state;
    const {
      id,
      type,
      label,
      validation
    } = this.props;
    const validationClassName = validation && 'error';
    const valueDom = [];
    valueDom.push(listvalue.map((data, index) => {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "textarea_list",
        key: data,
        __self: this,
        __source: {
          fileName: _jsxFileName$h,
          lineNumber: 130,
          columnNumber: 11
        }
      }, data, /*#__PURE__*/React__default.createElement("span", {
        role: "presentation",
        className: "textarea_list_remove",
        onClick: () => this.removeListValue(index),
        __self: this,
        __source: {
          fileName: _jsxFileName$h,
          lineNumber: 132,
          columnNumber: 13
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        src: EmailCloseIcon,
        alt: "email-close",
        __self: this,
        __source: {
          fileName: _jsxFileName$h,
          lineNumber: 137,
          columnNumber: 15
        }
      })));
    }));
    const DOM = /*#__PURE__*/React__default.createElement("div", {
      className: `inputmultiplevalue ${inputFocus} ${validationClassName}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$h,
        lineNumber: 144,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("label", {
      htmlFor: id,
      __self: this,
      __source: {
        fileName: _jsxFileName$h,
        lineNumber: 147,
        columnNumber: 9
      }
    }, label), /*#__PURE__*/React__default.createElement("div", {
      className: "textarea_wrapper",
      __self: this,
      __source: {
        fileName: _jsxFileName$h,
        lineNumber: 148,
        columnNumber: 9
      }
    }, valueDom, /*#__PURE__*/React__default.createElement("input", {
      className: "textarea",
      rows: "1",
      wrap: "hard",
      value: textareavalue,
      id: id,
      type: type,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      ref: this.inputRef,
      onChange: this.onChange,
      style: {
        width: `${width} px`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName$h,
        lineNumber: 150,
        columnNumber: 11
      }
    })));
    return DOM;
  }

}
InputMultipleValue.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.bool,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  validationChange: PropTypes.func,
  getEmailAddressList: PropTypes.func
};
InputMultipleValue.defaultProps = {
  id: '',
  type: '',
  label: '',
  validation: false,
  value: '',
  onFocus: () => {},
  onChange: () => {},
  validationChange: () => {},
  getEmailAddressList: () => {}
};

/* loaded by smart-asset */
require("../src/components/LimitCard/LimitCard.scss");

var _jsxFileName$i = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/LimitCard/LimitCard.js";
const LimitCard = props => {
  const {
    mainText,
    subText,
    heightValue,
    subTextColor
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "limitCard",
    style: heightValue && {
      height: `${heightValue}px`,
      minHeight: `${heightValue}px`
    },
    __self: undefined,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "limitCard__mainText",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 18,
      columnNumber: 7
    }
  }, mainText), /*#__PURE__*/React__default.createElement("div", {
    className: `limitCard__subText ${subTextColor}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 19,
      columnNumber: 7
    }
  }, subText));
  return Dom;
};
LimitCard.propTypes = {
  mainText: PropTypes.string,
  subText: PropTypes.string
};
LimitCard.defaultProps = {
  mainText: '',
  subText: ''
};

/* loaded by smart-asset */
require("../src/components/LunchOrderCalendar/LunchOrderCalendar.scss");

/* loaded by smart-asset */
var arrowLeftIcon = require("../src/assets/arrow-left.svg");

/* loaded by smart-asset */
var arrowRightIcon = require("../src/assets/arrow-right.svg");

var _jsxFileName$j = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/LunchOrderCalendar/LunchOrderCalendar.js";
let initialX = null;
let initialY = null;
class LunchOrderCalendar extends Component {
  constructor(...args) {
    super(...args);

    this.handleTouchStart = e => {
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    };

    this.handleTouchMove = e => {
      if (initialX === null) return;
      if (initialY === null) return;
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = initialX - currentX;
      const diffY = initialY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        const {
          leftArrowClick,
          incrementWeek
        } = this.props;

        if (diffX > 0) {
          const {
            rightArrowClick
          } = this.props;
          if (incrementWeek < 15) rightArrowClick(); // swiped left
        } else {
          // eslint-disable-next-line no-lonely-if
          if (incrementWeek > 0) leftArrowClick(); // swiped right
        }
      }

      initialX = null;
      initialY = null;
      e.preventDefault();
    };
  }

  componentDidMount() {
    const myElement = document && document.getElementsByClassName('calendar')[0];

    if (myElement && window.innerWidth < 768) {
      myElement.addEventListener('touchstart', this.handleTouchStart, false);
      myElement.addEventListener('touchmove', this.handleTouchMove, false);
    }
  }

  render() {
    const {
      leftArrowClick,
      dateList,
      activeDate,
      rightArrowClick,
      selectedDateList,
      contentClick,
      incrementWeek
    } = this.props;
    const calenderDom = dateList.map((data, index) => {
      const cart = selectedDateList[data.format('YYYY-MM-DD')];
      const doesCartHaveItems = cart && Object.keys(cart).length > 0;

      if (index >= incrementWeek && index < incrementWeek + 5) {
        const classNameCustom = `calendar_item
          ${activeDate === data.format('YYYY-MM-DD') ? 'active' : ''} `;
        return /*#__PURE__*/React__default.createElement("div", {
          key: `${data}${incrementWeek}`,
          className: classNameCustom,
          role: "presentation",
          onClick: () => contentClick(data.format('YYYY-MM-DD')),
          __self: this,
          __source: {
            fileName: _jsxFileName$j,
            lineNumber: 71,
            columnNumber: 11
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: doesCartHaveItems ? 'calendar_item__selected' : '',
          __self: this,
          __source: {
            fileName: _jsxFileName$j,
            lineNumber: 77,
            columnNumber: 13
          }
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "calendar_item__day u_mobile_display_block",
          __self: this,
          __source: {
            fileName: _jsxFileName$j,
            lineNumber: 80,
            columnNumber: 13
          }
        }, data.format('ddd')), /*#__PURE__*/React__default.createElement("div", {
          className: "calendar_item__day u_mobile_display_none",
          __self: this,
          __source: {
            fileName: _jsxFileName$j,
            lineNumber: 83,
            columnNumber: 13
          }
        }, data.format('dddd')), /*#__PURE__*/React__default.createElement("div", {
          className: "calendar_item__date",
          __self: this,
          __source: {
            fileName: _jsxFileName$j,
            lineNumber: 86,
            columnNumber: 13
          }
        }, data.format('DD')));
      }

      return null;
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: "calendar",
      __self: this,
      __source: {
        fileName: _jsxFileName$j,
        lineNumber: 94,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: `calendar_left ${incrementWeek === 0 ? 'disabled' : ''}`,
      role: "presentation",
      onClick: incrementWeek > 0 ? () => leftArrowClick() : null,
      __self: this,
      __source: {
        fileName: _jsxFileName$j,
        lineNumber: 95,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: arrowLeftIcon,
      alt: "left",
      __self: this,
      __source: {
        fileName: _jsxFileName$j,
        lineNumber: 100,
        columnNumber: 11
      }
    })), calenderDom, /*#__PURE__*/React__default.createElement("div", {
      className: `calendar_right ${incrementWeek === 15 ? 'disabled' : ''}`,
      role: "presentation",
      onClick: incrementWeek < 15 ? () => rightArrowClick() : null,
      __self: this,
      __source: {
        fileName: _jsxFileName$j,
        lineNumber: 103,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: arrowRightIcon,
      alt: "right",
      __self: this,
      __source: {
        fileName: _jsxFileName$j,
        lineNumber: 108,
        columnNumber: 11
      }
    })));
  }

}
LunchOrderCalendar.propTypes = {
  leftArrowClick: PropTypes.func,
  rightArrowClick: PropTypes.func,
  contentClick: PropTypes.func,
  incrementWeek: PropTypes.number,
  selectedDateList: PropTypes.shape({}),
  dateList: PropTypes.arrayOf(PropTypes.shape({})),
  activeDate: PropTypes.string
};
LunchOrderCalendar.defaultProps = {
  leftArrowClick: () => {},
  rightArrowClick: () => {},
  contentClick: () => {},
  incrementWeek: 0,
  selectedDateList: {},
  dateList: [],
  activeDate: ''
};

/* loaded by smart-asset */
require("../src/components/MealListing/MealListing.scss");

/* loaded by smart-asset */
var food_item_placeholder = require("../src/assets/food_item_placeholder.png");

var _jsxFileName$k = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/MealListing/MealListing.js";
const MealListing = props => {
  const {
    item,
    onClick,
    categoryuuid,
    isInactive
  } = props;
  const {
    image_urls
  } = item;
  const imageUrl = Array.isArray(image_urls) ? image_urls[0] : food_item_placeholder;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `mealListing-card${isInactive ? ` mealListing-card--inactive` : ''}`,
    role: "presentation",
    onClick: () => onClick(item, categoryuuid),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    role: "presentation",
    className: "mealListing-card__img",
    style: {
      backgroundImage: `url('${imageUrl}')`
    },
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 26,
      columnNumber: 9
    }
  }, item.is_added ? /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__added",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 32,
      columnNumber: 13
    }
  }, "Added") : ''), /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content_details",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "mealListing-card__content_name",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 38,
      columnNumber: 11
    }
  }, item.name), /*#__PURE__*/React__default.createElement("p", {
    className: "mealListing-card__content_description",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 39,
      columnNumber: 11
    }
  }, item.description)), item.allergies && item.allergies.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content_details mealListing-card__content_allergies",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 44,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("h4", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 45,
      columnNumber: 13
    }
  }, "Allergies"), /*#__PURE__*/React__default.createElement("ul", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 46,
      columnNumber: 13
    }
  }, item.allergies.map(allergy => /*#__PURE__*/React__default.createElement("li", {
    key: allergy.uuid,
    title: allergy.description,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 48,
      columnNumber: 17
    }
  }, allergy.name)))), item.diets && item.diets.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content_details mealListing-card__content_diets",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 56,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("h4", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 57,
      columnNumber: 13
    }
  }, "Diets"), /*#__PURE__*/React__default.createElement("ul", {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 58,
      columnNumber: 13
    }
  }, item.diets.map(diet => /*#__PURE__*/React__default.createElement("li", {
    key: diet.uuid,
    title: diet.description,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 60,
      columnNumber: 17
    }
  }, diet.name)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: '1 1 auto'
    },
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 67,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content_details",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mealListing-card__content_price",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 69,
      columnNumber: 11
    }
  }, item.price), /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: 'right'
    },
    __self: undefined,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 70,
      columnNumber: 11
    }
  }, LocalStorage.getCurrency() || 'AED'))));
};
MealListing.propTypes = {
  onClick: PropTypes.func,
  categoryuuid: PropTypes.string,
  item: PropTypes.shape({})
};
MealListing.defaultProps = {
  onClick: () => {},
  categoryuuid: '',
  item: {}
};

/* loaded by smart-asset */
require("../src/components/NutritionConsumption/NutritionConsumption.scss");

var _jsxFileName$l = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/NutritionConsumption/NutritionConsumption.js";
const NutritionConsumption = props => {
  const {
    filterdata,
    onfilterValueClick,
    filterActiveValue,
    contentData
  } = props;
  const {
    nutrition_details
  } = contentData;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-cons_overlay",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(FilterDropdown, {
    data: filterdata,
    filterActiveValue: filterActiveValue,
    onClick: onfilterValueClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-cons__score_wrapper",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 26,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-cons__score u_margin_1rem_rgt",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(LimitCard, {
    mainText: "YACOB score",
    subText: `${contentData.yacob_score}`,
    heightValue: 120,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 28,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-cons__score",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 34,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(LimitCard, {
    mainText: "YACOB score difference",
    subText: `${contentData.yacob_difference}%`,
    heightValue: 120,
    subTextColor: "red",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 35,
      columnNumber: 11
    }
  }))), nutrition_details && nutrition_details.data && /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-cons__chart",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(PieChart, {
    data: nutrition_details.data,
    radius: 150,
    hole: 0,
    colors: nutrition_details.colors,
    labels: true,
    percent: true,
    strokeWidth: 0,
    labelValue: nutrition_details.labelValue,
    startAngle: -90,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 45,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "u_overlay",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 58,
      columnNumber: 7
    }
  }, "Coming Soon..."));
  return Dom;
};
NutritionConsumption.propTypes = {
  filterdata: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    displayName: PropTypes.string,
    index: PropTypes.number
  })),
  onfilterValueClick: PropTypes.func,
  filterActiveValue: PropTypes.string,
  contentData: PropTypes.shape({})
};
NutritionConsumption.defaultProps = {
  filterdata: [],
  onfilterValueClick: () => {},
  filterActiveValue: '',
  contentData: {}
};

/* loaded by smart-asset */
require("../src/components/NutritionItems/NutritionItems.scss");

var _jsxFileName$m = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/NutritionItems/NutritionItems.js";
const NutritionItems = props => {
  const {
    itemsData,
    tableItemsSort,
    onChangePagination,
    totalRecords,
    columns
  } = props;
  const mobileTableView = itemsData.map(data => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list",
      key: data.item_uuid,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 20,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_left",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 21,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_bold",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 22,
        columnNumber: 11
      }
    }, data.food_item_name), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_order",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 25,
        columnNumber: 11
      }
    }, moment(data.ordered_date).format('DD MMMM, YYYY'))), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_right",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 29,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_score",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 30,
        columnNumber: 11
      }
    }, data.yacob_score), /*#__PURE__*/React__default.createElement("div", {
      className: "nutrition-items__table_list_bold",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$m,
        lineNumber: 33,
        columnNumber: 11
      }
    }, data.item_calories)));
  });
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-items",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 42,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-items__table",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 43,
      columnNumber: 7
    }
  }, window.innerWidth > 768 ? /*#__PURE__*/React__default.createElement(Table, {
    data: itemsData,
    columns: columns,
    tableSort: tableItemsSort,
    itemkey: "item_uuid",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 45,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "nutrition-items__table_list_wrapper",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 52,
      columnNumber: 11
    }
  }, mobileTableView)), /*#__PURE__*/React__default.createElement(Pagination, {
    totalPage: Math.ceil(totalRecords / 20),
    onChange: onChangePagination,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 57,
      columnNumber: 7
    }
  }));
  return Dom;
};
NutritionItems.propTypes = {
  itemsData: PropTypes.arrayOf(PropTypes.shape({})),
  onChangePagination: PropTypes.func,
  totalRecords: PropTypes.number
};
NutritionItems.defaultProps = {
  itemsData: [],
  onChangePagination: () => {},
  totalRecords: 0
};

/* loaded by smart-asset */
require("../src/components/OrderStatus/OrderStatus.scss");

/* loaded by smart-asset */
var CompleteDesktopIcon = require("../src/assets/complete-desktop.svg");

/* loaded by smart-asset */
var CompleteMobileIcon = require("../src/assets/complete-mobile.svg");

/* loaded by smart-asset */
var CircleIcon = require("../src/assets/circle.svg");

var _jsxFileName$n = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/OrderStatus/OrderStatus.js";
const OrderStatus = props => {
  const {
    data,
    onClick
  } = props;
  let Dom = null;

  if (data && data.status === 'success') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__image",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 19,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CompleteDesktopIcon,
      alt: "complete",
      className: "orderStatus__image_desktop",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 20,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("img", {
      src: CompleteMobileIcon,
      alt: "complete",
      className: "orderStatus__image_mobile",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 25,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 31,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: data.data,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 32,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 34,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: "Continue",
      size: "big",
      type: "block",
      onClick: () => onClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 35,
        columnNumber: 11
      }
    })));
  } else if (data && data.status === 'error') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__image",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 47,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CircleIcon,
      alt: "circle",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 48,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__image_error",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 49,
        columnNumber: 11
      }
    }, "!")), /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 51,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: data.data,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 52,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "orderStatus__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 54,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: "Try Again",
      size: "big",
      type: "block",
      color: "lightgrey",
      onClick: () => onClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$n,
        lineNumber: 55,
        columnNumber: 11
      }
    })));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "orderStatus",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 67,
      columnNumber: 10
    }
  }, Dom);
};
OrderStatus.propTypes = {
  data: PropTypes.shape({})
};
OrderStatus.defaultProps = {
  data: {}
};

/* loaded by smart-asset */
require("../src/components/Pagination/Pagination.scss");

var _jsxFileName$o = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Pagination/Pagination.js";
class Pagination extends Component {
  constructor(props) {
    super(props);

    this.setArray = end => {
      const array = [];
      let start;

      if (end > 5) {
        start = end - 4;
      } else {
        start = 1;
      }

      for (let i = start; i <= end; i += 1) {
        array.push(i);
      }

      return array;
    };

    this.setActivePage = data => {
      const {
        onChange
      } = this.props;
      this.setState({
        activePage: data
      });
      onChange(data);
    };

    this.prevPage = () => {
      const {
        activePage,
        array
      } = this.state;
      const {
        totalPage
      } = this.props;

      if (activePage > 1) {
        if (activePage - 1 >= 5) {
          const prevarray = this.setArray(activePage - 1);
          this.setState({
            array: prevarray
          });
        } else if (activePage - 1 < 5 && array[0] !== 1) {
          const prevarray = this.setArray(totalPage >= 5 ? 5 : totalPage);
          this.setState({
            array: prevarray
          });
        }

        this.setActivePage(activePage - 1);
      }
    };

    this.nextPage = () => {
      const {
        activePage,
        totalPage
      } = this.state;

      if (activePage !== totalPage) {
        if (activePage + 1 > 5) {
          const array = this.setArray(activePage + 1);
          this.setState({
            array
          });
        }

        this.setActivePage(activePage + 1);
      }
    };

    this.state = {
      totalPage: props.totalPage,
      array: this.setArray(props.totalPage >= 5 ? 5 : props.totalPage),
      activePage: 1
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      totalPage
    } = this.props;
    if (nextProps.totalPage && nextProps.totalPage !== totalPage) this.setState({
      totalPage: nextProps.totalPage,
      array: this.setArray(nextProps.totalPage >= 5 ? 5 : nextProps.totalPage),
      activePage: 1
    });
  }

  render() {
    const {
      totalPage,
      array,
      activePage
    } = this.state;
    return /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 78,
        columnNumber: 7
      }
    }, totalPage > 0 ? /*#__PURE__*/React__default.createElement("ul", {
      className: "pagination_list",
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 80,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement("li", {
      role: "presentation",
      className: "pagination_list_item prev",
      onClick: () => this.prevPage(),
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 81,
        columnNumber: 13
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: DownArrowSvg,
      alt: "Downarrow",
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 86,
        columnNumber: 15
      }
    })), array.map(data => {
      return /*#__PURE__*/React__default.createElement("li", {
        key: data,
        role: "presentation",
        className: `pagination_list_item ${activePage === data ? 'active' : ''}`,
        onClick: () => this.setActivePage(data),
        __self: this,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 90,
          columnNumber: 17
        }
      }, data);
    }), /*#__PURE__*/React__default.createElement("li", {
      role: "presentation",
      className: "pagination_list_item next",
      onClick: () => this.nextPage(),
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 102,
        columnNumber: 13
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: DownArrowSvg,
      alt: "Downarrow",
      __self: this,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 107,
        columnNumber: 15
      }
    }))) : '');
  }

}
Pagination.propTypes = {
  totalPage: PropTypes.number,
  onChange: PropTypes.func
};
Pagination.defaultProps = {
  totalPage: 0,
  onChange: () => {}
};

/* loaded by smart-asset */
require("../src/components/Payment/Payment.scss");

var _jsxFileName$p = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Payment/Payment.js";
const Payment = props => {
  const {
    t
  } = useTranslation();
  const {
    onChange,
    onChangeRadio,
    onClickPay,
    paybtnshowloader,
    toggleId,
    showUseMyBalance,
    toggleValue,
    paymentSelection,
    title,
    description,
    balance,
    totalAmount
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "payment",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: title,
    description: description,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 34,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "payment__card",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 35,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(LimitCard, {
    mainText: t('total'),
    subText: `${LocalStorage.getCurrency()} ${totalAmount}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 36,
      columnNumber: 9
    }
  }), showUseMyBalance && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaymentCard, {
    mainText: t('use_my_balance'),
    subText: `${t('use_all_my_balance')} (${LocalStorage.getCurrency()} ${balance})`,
    onChange: onChange,
    toggleValue: balance <= 0 ? false : toggleValue,
    hasToggle: true,
    id: toggleId,
    toggleDisabled: balance <= 0,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 42,
      columnNumber: 13
    }
  }), /*#__PURE__*/React__default.createElement(ContentDivider, {
    lineDivider: true,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 53,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(RadioButton, {
    name: "paymentSelection",
    value: "Credit card",
    checked: paymentSelection,
    onChange: onChangeRadio,
    key: "creditRadioValue",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(PaymentCard, {
    mainText: t('pay_with_credit_card'),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 64,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "payment__card_btn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 67,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: t('pay'),
    size: "big",
    type: "block",
    onClick: onClickPay,
    showloader: paybtnshowloader,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 68,
      columnNumber: 11
    }
  }))));
  return Dom;
};
Payment.propTypes = {
  onChange: PropTypes.func,
  onChangeRadio: PropTypes.func,
  onClickPay: PropTypes.func,
  toggleValue: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  showUseMyBalance: PropTypes.bool,
  paymentSelection: PropTypes.string,
  balance: PropTypes.number,
  paybtnshowloader: PropTypes.bool,
  totalAmount: PropTypes.string
};
Payment.defaultProps = {
  onChange: () => {},
  onChangeRadio: () => {},
  onClickPay: () => {},
  toggleValue: false,
  title: '',
  description: '',
  showUseMyBalance: false,
  paymentSelection: '',
  balance: 0,
  paybtnshowloader: false,
  totalAmount: ''
};

/* loaded by smart-asset */
require("../src/components/PaymentCard/PaymentCard.scss");

var _jsxFileName$q = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/PaymentCard/PaymentCard.js";
const PaymentCard = props => {
  const {
    color,
    mainText,
    subText,
    onChange,
    toggleValue,
    hasToggle,
    className,
    onClick,
    id,
    toggleDisabled
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: `paymentCard ${className && className}`,
    role: "presentation",
    onClick: onClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "paymentCard_content",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "paymentCard__mainText",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 28,
      columnNumber: 9
    }
  }, mainText), /*#__PURE__*/React__default.createElement("div", {
    className: "paymentCard__subText",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 29,
      columnNumber: 9
    }
  }, subText)), hasToggle && /*#__PURE__*/React__default.createElement(ToggleButton, {
    id: id,
    onChange: onChange,
    checked: toggleValue,
    disabled: toggleDisabled,
    color: color,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 32,
      columnNumber: 9
    }
  }));
  return Dom;
};
PaymentCard.propTypes = {
  mainText: PropTypes.string,
  subText: PropTypes.string,
  hasToggle: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  toggleValue: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  toggleDisabled: PropTypes.bool,
  color: PropTypes.string
};
PaymentCard.defaultProps = {
  mainText: '',
  subText: '',
  hasToggle: false,
  onChange: () => {},
  onClick: () => {},
  toggleValue: false,
  className: '',
  id: '',
  toggleDisabled: false,
  color: ''
};

var _jsxFileName$r = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/PieChart/PieChart.js";
const PieChart = props => {
  const {
    colors,
    labels,
    labelValue,
    hole,
    radius,
    data,
    stroke,
    strokeWidth
  } = props;
  let {
    startAngle
  } = props;
  const colorsLength = colors.length;
  const diameter = radius * 2;
  const sum = data.reduce(function (carry, current) {
    return carry + current;
  }, 0);
  return /*#__PURE__*/React__default.createElement("svg", {
    width: diameter,
    height: diameter,
    viewBox: `0 0 ${diameter} ${diameter}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 23,
      columnNumber: 5
    }
  }, data.map((slice, sliceIndex) => {
    const nextAngle = startAngle;
    const angle = slice / sum * 360;
    const percent = slice / sum * 100;
    startAngle += angle;
    return /*#__PURE__*/React__default.createElement(PieChartSlice, {
      key: slice,
      value: slice,
      percent: percent,
      percentValue: percent.toFixed(1),
      startAngle: nextAngle,
      angle: angle,
      radius: radius,
      hole: radius - hole,
      trueHole: hole,
      showLabel: labels,
      labelValue: labelValue[sliceIndex % colorsLength],
      fill: colors[sliceIndex % colorsLength],
      stroke: stroke,
      strokeWidth: strokeWidth,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$r,
        lineNumber: 35,
        columnNumber: 11
      }
    });
  }));
};

/* loaded by smart-asset */
require("../src/components/PieChartSlice/PieChartSlice.scss");

var _jsxFileName$s = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/PieChartSlice/PieChartSlice.js";
class PieChartSlice extends Component {
  constructor(props) {
    super(props);

    this.animate = () => {
      this.draw(0);
    };

    this.getAnglePoint = (startAngle, endAngle, radius, x, y) => {
      const x1 = x + radius * Math.cos(Math.PI * startAngle / 180);
      const y1 = y + radius * Math.sin(Math.PI * startAngle / 180);
      const x2 = x + radius * Math.cos(Math.PI * endAngle / 180);
      const y2 = y + radius * Math.sin(Math.PI * endAngle / 180);
      return {
        x1,
        y1,
        x2,
        y2
      };
    };

    this.draw = s => {
      const p = this.props;
      const path = [];
      const self = this;
      let c;
      const step = p.angle / (37.5 / 2);

      if (s + step > p.angle) {
        s = p.angle;
      }

      const a = this.getAnglePoint(p.startAngle, p.startAngle + s, p.radius, p.radius, p.radius);
      const b = this.getAnglePoint(p.startAngle, p.startAngle + s, p.radius - p.hole, p.radius, p.radius);
      path.push(`M${a.x1},${a.y1}`);
      path.push(`A${p.radius},${p.radius} 0 ${s > 180 ? 1 : 0},1 ${a.x2},${a.y2}`);
      path.push(`L${b.x2},${b.y2}`);
      path.push(`A${p.radius - p.hole},${p.radius - p.hole} 0 ${s > 180 ? 1 : 0},0 ${b.x1},${b.y1}`);
      path.push('Z');
      this.setState({
        path: path.join(' ')
      });

      if (s < p.angle) {
        setTimeout(function () {
          self.draw(s + step);
        }, 16);
      } else if (p.showLabel) {
        c = this.getAnglePoint(p.startAngle, p.startAngle + p.angle / 2, p.radius / 2 + p.trueHole / 2, p.radius, p.radius);
        this.setState({
          x: c.x2,
          y: c.y2
        });
      }
    };

    this.state = {
      path: '',
      x: 0,
      y: 0
    };
  }

  componentDidMount() {
    this.animate();
  }

  componentWillReceiveProps() {
    this.setState({
      path: ''
    });
    this.animate();
  }

  render() {
    const {
      path,
      x,
      y
    } = this.state;
    const {
      fill,
      stroke,
      labelValue,
      strokeWidth,
      showLabel,
      percentValue,
      percent,
      value
    } = this.props;
    return /*#__PURE__*/React__default.createElement("g", {
      overflow: "hidden",
      __self: this,
      __source: {
        fileName: _jsxFileName$s,
        lineNumber: 109,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("path", {
      d: path,
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth || 3,
      __self: this,
      __source: {
        fileName: _jsxFileName$s,
        lineNumber: 110,
        columnNumber: 9
      }
    }), showLabel && percentValue > 5 ? /*#__PURE__*/React__default.createElement("text", {
      className: "pieChart_label",
      x: x,
      y: y,
      fill: labelValue === 'Neutral' ? '#3f3f49' : '#fff',
      textAnchor: "middle",
      __self: this,
      __source: {
        fileName: _jsxFileName$s,
        lineNumber: 117,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement("tspan", {
      x: x,
      y: y,
      className: "pieChart_label_percent",
      __self: this,
      __source: {
        fileName: _jsxFileName$s,
        lineNumber: 124,
        columnNumber: 13
      }
    }, percent ? `${percent}% ` : value), /*#__PURE__*/React__default.createElement("tspan", {
      className: "pieChart_label_name",
      x: x,
      y: y + 20,
      __self: this,
      __source: {
        fileName: _jsxFileName$s,
        lineNumber: 127,
        columnNumber: 13
      }
    }, labelValue)) : null);
  }

}

/* loaded by smart-asset */
require("../src/components/ProgressTrack/ProgressTrack.scss");

var _jsxFileName$t = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ProgressTrack/ProgressTrack.js";
const ProgressTrack = props => {
  const {
    track,
    onClick,
    progressTrackDisplay
  } = props;
  const {
    t
  } = useTranslation();
  const Dom = /*#__PURE__*/React__default.createElement("ul", {
    className: `progressTrack u_list_style_none ${progressTrackDisplay}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 12,
      columnNumber: 5
    }
  }, track && track.length && track.map(data => /*#__PURE__*/React__default.createElement("li", {
    role: "presentation",
    onClick: () => onClick(data.key, data.index, data.route),
    key: data.key,
    className: data.status ? `progressTrack_item ${data.status} ${progressTrackDisplay}` : `progressTrack_item ${progressTrackDisplay}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 16,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "progressTrack_item_name",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 26,
      columnNumber: 13
    }
  }, t(data.displayName)))));
  return Dom;
};
ProgressTrack.propTypes = {
  track: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    displayName: PropTypes.string
  })),
  onClick: PropTypes.func
};
ProgressTrack.defaultProps = {
  track: []
};

/* loaded by smart-asset */
require("../src/components/RadioButton/RadioButton.scss");

var _jsxFileName$u = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/RadioButton/RadioButton.js";
const RadioButton = props => {
  const {
    onChange,
    checked,
    children,
    value,
    color,
    disabled,
    leftContent,
    name
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("label", {
    className: `radioButton ${color}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 19,
      columnNumber: 5
    }
  }, children, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    value: value,
    name: name || 'radio',
    onChange: onChange,
    checked: checked === value,
    disabled: disabled,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `radioButton_custom ${leftContent ? 'leftContent' : ''}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 29,
      columnNumber: 7
    }
  }), leftContent && /*#__PURE__*/React__default.createElement("span", {
    className: "content",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 32,
      columnNumber: 23
    }
  }, leftContent || ''));
  return Dom;
};
RadioButton.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string
};
RadioButton.defaultProps = {
  onChange: () => {},
  checked: '',
  value: '',
  disabled: false
};

/* loaded by smart-asset */
require("../src/components/ReportCardLostSuccess/ReportCardLostSuccess.scss");

var _jsxFileName$v = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ReportCardLostSuccess/ReportCardLostSuccess.js";
const ReportCardLostSuccess = props => {
  const {
    successonClick
  } = props;
  const {
    t
  } = useTranslation();
  let Dom = null;
  const successText = 'Your card has been reported successfully';
  Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "reportcardlostSuccess__image success",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: CompleteDesktopIcon,
    alt: "complete",
    className: "reportcardlostSuccess__image_desktop",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 21,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: CompleteMobileIcon,
    alt: "complete",
    className: "reportcardlostSuccess__image_mobile",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 26,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "reportcardlostSuccess__text",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: successText,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 33,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "reportcardlostSuccess__btn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 35,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "u_margin_2rem_top_bot",
    text: t('continue'),
    size: "big",
    type: "block",
    onClick: successonClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 36,
      columnNumber: 9
    }
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "reportcardlostSuccess",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 47,
      columnNumber: 10
    }
  }, Dom);
};
ReportCardLostSuccess.propTypes = {
  successonClick: PropTypes.func
};
ReportCardLostSuccess.defaultProps = {
  successonClick: () => {}
};

/* loaded by smart-asset */
require("../src/components/ResetCheck/ResetCheck.scss");

/* loaded by smart-asset */
var CheckEmailIcon = require("../src/assets/email.svg");

var _jsxFileName$w = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ResetCheck/ResetCheck.js";
const ResetCheck = () => {
  const {
    t
  } = useTranslation();
  const Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
    src: CheckEmailIcon,
    alt: "complete",
    className: "resetCheck_image",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$w,
      lineNumber: 15,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: t('reset_password_email'),
    description: t('reset_password_email_description'),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$w,
      lineNumber: 16,
      columnNumber: 7
    }
  }));
  return Dom;
};

/* loaded by smart-asset */
require("../src/components/ResetDone/ResetDone.scss");

var _jsxFileName$x = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ResetDone/ResetDone.js";
const ResetDone = props => {
  const {
    onClick
  } = props;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "resetDone",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "resetDone_image",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 17,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: CompleteDesktopIcon,
    alt: "complete",
    className: "resetDone_image_desktop",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 18,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: CompleteMobileIcon,
    alt: "complete",
    className: "resetDone_image_mobile",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 23,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "resetDone_text",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 29,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: t('reset_password_done'),
    description: "",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 30,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "resetDone_button",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: t('proceed_to_login'),
    type: "block",
    size: "big",
    onClick: onClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 33,
      columnNumber: 9
    }
  })));
};

/* loaded by smart-asset */
require("../src/components/ResetPassword/ResetPassword.scss");

var _jsxFileName$y = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ResetPassword/ResetPassword.js";
const ResetPassword = prop => {
  const {
    onClick,
    inputvalue,
    validation,
    onChangeInput,
    validationChangeHandler,
    onFocusInput,
    currentFieldFocus,
    btnshowloader
  } = prop;
  const {
    t
  } = useTranslation();
  const Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: t('reset_password'),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 26,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "resetPassword_input",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
    id: "email",
    label: t('email'),
    type: "email",
    required: true,
    value: inputvalue.email,
    onChange: onChangeInput,
    validation: validation.email,
    validationChange: validationChangeHandler,
    onFocus: onFocusInput,
    currentFieldFocus: currentFieldFocus,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClick,
    text: t('confirm'),
    type: "block",
    size: "big",
    showloader: btnshowloader,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 40,
      columnNumber: 9
    }
  })));
  return Dom;
};
ResetPassword.propTypes = {
  onClick: PropTypes.func,
  inputvalue: PropTypes.shape({}),
  validation: PropTypes.shape({}),
  onChangeInput: PropTypes.func,
  validationChangeHandler: PropTypes.func,
  onFocusInput: PropTypes.func,
  currentFieldFocus: PropTypes.string,
  btnshowloader: PropTypes.bool
};
ResetPassword.defaultProps = {
  onClick: () => {},
  inputvalue: {},
  validation: {},
  onChangeInput: () => {},
  validationChangeHandler: () => {},
  onFocusInput: () => {},
  currentFieldFocus: '',
  btnshowloader: false
};

/* loaded by smart-asset */
require("../src/components/ShareCredit/ShareCredit.scss");

/* loaded by smart-asset */
var FacebookIcon = require("../src/assets/facebook.svg");

/* loaded by smart-asset */
var TwitterIcon = require("../src/assets/twitter.svg");

/* loaded by smart-asset */
var LinkedInIcon = require("../src/assets/linkedin.svg");

var _jsxFileName$z = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ShareCredit/ShareCredit.js";
const ShareCredit = props => {
  const {
    link,
    copyLink,
    facebookShare,
    twitterShare,
    linkedInShare
  } = props;
  const {
    t
  } = useTranslation();
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__link",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__link_text",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 17,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    value: link,
    id: "sharecredit__link_text",
    readOnly: true,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 18,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    role: "presentation",
    onClick: copyLink,
    className: "sharecredit__link_btn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 25,
      columnNumber: 9
    }
  }, t('copy'))), /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__social",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__social_icon facebook",
    role: "presentation",
    onClick: () => facebookShare(link),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 34,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: FacebookIcon,
    alt: "facebook",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 39,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__social_icon twitter",
    role: "presentation",
    onClick: () => twitterShare(link),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 41,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: TwitterIcon,
    alt: "twitter",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 46,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sharecredit__social_icon linkedIn",
    role: "presentation",
    onClick: () => linkedInShare(link),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 48,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: LinkedInIcon,
    alt: "linkedIn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 53,
      columnNumber: 11
    }
  }))));
  return Dom;
};
ShareCredit.propTypes = {
  copyLink: PropTypes.func,
  facebookShare: PropTypes.func,
  twitterShare: PropTypes.func,
  linkedInShare: PropTypes.func,
  link: PropTypes.string
};
ShareCredit.defaultProps = {
  copyLink: () => {},
  facebookShare: () => {},
  twitterShare: () => {},
  linkedInShare: () => {},
  link: ''
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildAllergy/SignupAddChildAllergy.scss");

/* loaded by smart-asset */
var InfoIcon = require("../src/assets/info.jpg");

var _jsxFileName$A = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildAllergy/SignupAddChildAllergy.js";
class SignupAddChildAllergyBase extends Component {
  constructor(props) {
    super(props);

    this.onChangeAdditional = e => {
      this.setState({
        additionalRestrictionValue: e.target.value
      });
    };

    this.onClickAdditional = () => {
      this.setState({
        additionalRestriction: true
      });
    };

    this.onClickSubmit = () => {
      const {
        onClickAddChildAllergy
      } = this.props;
      const {
        allergySelected,
        additionalRestrictionValue
      } = this.state;
      const filterallergySelected = [];

      for (const key in allergySelected) {
        if (allergySelected[key]) {
          filterallergySelected.push({
            allergy_uuid: key,
            allergy_level: allergySelected[key]
          });
        }
      }

      const payload = {
        allergies: filterallergySelected,
        allergy_custom: additionalRestrictionValue
      };
      onClickAddChildAllergy(payload, allergySelected);
    };

    this.onAllergySelector = (id, value) => {
      const {
        allergySelected
      } = this.state;
      allergySelected[id] = value;
      this.setState({
        allergySelected
      });
    };

    const {
      data
    } = props;
    this.state = {
      additionalRestriction: data && data.allergy_custom ? data.allergy_custom : '',
      additionalRestrictionValue: data && data.allergy_custom ? data.allergy_custom : '',
      allergyList: props.addChildAllergyList || [],
      allergySelected: props.allergySelected
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      addChildAllergyList,
      allergySelected
    } = this.props;

    if (nextProps.addChildAllergyList !== addChildAllergyList) {
      this.setState({
        allergyList: nextProps.addChildAllergyList
      });
    }

    if (nextProps.allergySelected !== allergySelected) {
      this.setState({
        allergySelected: nextProps.allergySelected
      });
    }

    if (nextProps.data && nextProps.data.allergy_custom) {
      this.setState({
        additionalRestriction: nextProps.data.allergy_custom,
        additionalRestrictionValue: nextProps.data.allergy_custom
      });
    }
  }

  render() {
    const {
      additionalRestriction,
      additionalRestrictionValue,
      allergyList,
      allergySelected
    } = this.state;
    const {
      showloader,
      showbtnloader,
      t
    } = this.props;
    let allergyDom = [];
    const contentDom = [];
    allergyDom = allergyList.map(data => {
      return /*#__PURE__*/React__default.createElement(ToggleSeverity, {
        title: data.name,
        id: data.uuid,
        key: data.uuid,
        severity: allergySelected && allergySelected[data.uuid],
        onAllergySelector: this.onAllergySelector,
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 93,
          columnNumber: 9
        }
      });
    });

    if (showloader) {
      contentDom.push( /*#__PURE__*/React__default.createElement(Loader, {
        key: "loader",
        fitContent: "full",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 103,
          columnNumber: 23
        }
      }));
    } else {
      contentDom.push( /*#__PURE__*/React__default.createElement("div", {
        key: "allergy",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 106,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "signup_title",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 107,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement(TitleDescription, {
        title: t('add_child'),
        description: t('add_child_allergies_description'),
        descriptionClass: "signupallergy_description",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 108,
          columnNumber: 13
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "signupallergy_info",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 114,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        src: InfoIcon,
        alt: "info",
        className: "signupallergy_info_icon",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 115,
          columnNumber: 13
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "signupallergy_info_content",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 120,
          columnNumber: 13
        }
      }, "Eggs, milk, and peanuts are the most common causes of food allergies in children, with wheat, soy, and tree nuts also included. Peanuts, tree nuts, fish, and shellfish commonly cause the most severe reactions.")), /*#__PURE__*/React__default.createElement("div", {
        className: "signupallergy_input",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 127,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "signupallergy_input_list",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 128,
          columnNumber: 13
        }
      }, allergyDom), additionalRestriction ? /*#__PURE__*/React__default.createElement(Textarea, {
        title: t('additional_allergy'),
        value: additionalRestrictionValue,
        onChange: this.onChangeAdditional,
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 130,
          columnNumber: 15
        }
      }) : /*#__PURE__*/React__default.createElement(Button, {
        onClick: this.onClickAdditional,
        className: "u_margin_1rem_top_bot",
        type: "block",
        text: t('specify_additional_allergy'),
        size: "big",
        color: "white",
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 136,
          columnNumber: 15
        }
      }), /*#__PURE__*/React__default.createElement(Button, {
        className: "u_margin_1rem_top_bot",
        type: "block",
        text: t('save'),
        size: "big",
        showloader: showbtnloader,
        onClick: this.onClickSubmit,
        __self: this,
        __source: {
          fileName: _jsxFileName$A,
          lineNumber: 145,
          columnNumber: 13
        }
      }))));
    }

    return contentDom;
  }

}
const SignupAddChildAllergy = withTranslation()(SignupAddChildAllergyBase);
SignupAddChildAllergy.propTypes = {
  onClickAddChildAllergy: PropTypes.func,
  data: PropTypes.shape({}),
  addChildAllergyList: PropTypes.arrayOf(PropTypes.shape({})),
  allergySelected: PropTypes.shape({})
};
SignupAddChildAllergy.defaultProps = {
  onClickAddChildAllergy: () => {},
  data: {},
  addChildAllergyList: [],
  allergySelected: {}
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildDiet/SignupAddChildDiet.scss");

var _jsxFileName$B = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildDiet/SignupAddChildDiet.js";
class SignupAddChildDietBase extends Component {
  constructor(props) {
    super(props);

    this.onChangeAdditional = e => {
      this.setState({
        additionalRestrictionValue: e.target.value
      });
    };

    this.onChangeRadio = e => {
      this.setState({
        radioSelected: e.target.value
      });
    };

    this.onClickAdditional = () => {
      this.setState({
        additionalRestriction: true
      });
    };

    this.dietuuidValueHandler = () => {
      const {
        radioSelected
      } = this.state;
      if (!radioSelected) return null;
      return radioSelected;
    };

    this.onClickSubmit = () => {
      const {
        onClickAddChildDiet
      } = this.props;
      const {
        additionalRestrictionValue
      } = this.state;
      const data = {
        diet_uuid: this.dietuuidValueHandler(),
        diet_custom: additionalRestrictionValue
      };
      onClickAddChildDiet(data);
    };

    const {
      data: _data
    } = props;
    this.state = {
      radioSelected: _data && _data.diet_uuid ? _data.diet_uuid : '',
      additionalRestriction: _data && _data.diet_custom,
      additionalRestrictionValue: _data && _data.diet_custom,
      dietList: props.addChildDietList || []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.addChildDietList) {
      this.setState({
        dietList: nextProps.addChildDietList
      });
    }

    if (nextProps.data) {
      this.setState({
        radioSelected: nextProps.data && nextProps.data.diet_uuid ? nextProps.data.diet_uuid : '',
        additionalRestriction: nextProps.data && nextProps.data.diet_custom,
        additionalRestrictionValue: nextProps.data && nextProps.data.diet_custom
      });
    }
  }

  render() {
    const {
      radioSelected,
      additionalRestriction,
      additionalRestrictionValue,
      dietList
    } = this.state;
    const {
      isEditable,
      showloader,
      showbtnloader,
      t
    } = this.props;
    const contentDom = [];
    let dietDom = [];
    dietDom = dietList.map(data => {
      return /*#__PURE__*/React__default.createElement(RadioButton, {
        name: "radio",
        value: data.uuid,
        checked: radioSelected,
        onChange: this.onChangeRadio,
        key: data.uuid,
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 82,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "signupdiet_input_radioitem",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 89,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "signupdiet_input_radioitem_title",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 90,
          columnNumber: 13
        }
      }, data.name), /*#__PURE__*/React__default.createElement("div", {
        className: "signupdiet_input_radioitem_des",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 91,
          columnNumber: 13
        }
      }, data.description)));
    });

    if (showloader) {
      contentDom.push( /*#__PURE__*/React__default.createElement(Loader, {
        key: "loader",
        fitContent: "full",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 100,
          columnNumber: 23
        }
      }));
    } else {
      contentDom.push( /*#__PURE__*/React__default.createElement("div", {
        key: "diet",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 103,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "signup_title",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 104,
          columnNumber: 11
        }
      }, /*#__PURE__*/React__default.createElement(TitleDescription, {
        title: t('add_child'),
        description: t('add_child_diet_description'),
        descriptionClass: "signupdiet_description",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 105,
          columnNumber: 13
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "signupdiet_input",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 111,
          columnNumber: 11
        }
      }, dietDom, additionalRestriction ? /*#__PURE__*/React__default.createElement(Textarea, {
        title: t('additional_restriction'),
        value: additionalRestrictionValue,
        onChange: this.onChangeAdditional,
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 114,
          columnNumber: 15
        }
      }) : /*#__PURE__*/React__default.createElement(Button, {
        onClick: this.onClickAdditional,
        className: "u_margin_1rem_top_bot",
        type: "block",
        text: t('specify_additional_restrictions'),
        size: "big",
        color: "white",
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 120,
          columnNumber: 15
        }
      }), /*#__PURE__*/React__default.createElement(Button, {
        className: "u_margin_1rem_top_bot",
        type: "block",
        text: isEditable ? t('save') : t('next'),
        size: "big",
        showloader: showbtnloader,
        onClick: this.onClickSubmit,
        __self: this,
        __source: {
          fileName: _jsxFileName$B,
          lineNumber: 129,
          columnNumber: 13
        }
      }))));
    }

    return contentDom;
  }

}
const SignupAddChildDiet = withTranslation()(SignupAddChildDietBase);
SignupAddChildDiet.propTypes = {
  onClickAddChildDiet: PropTypes.func,
  data: PropTypes.shape({})
};
SignupAddChildDiet.defaultProps = {
  onClickAddChildDiet: () => {},
  data: {}
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildPhysical/SignupAddChildPhysical.scss");

var _jsxFileName$C = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/utils/autosuggest.js";

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
} // school


function getSuggestionValueSchool(suggestion) {
  return suggestion.name;
}
function renderSuggestionSchool(suggestion) {
  return /*#__PURE__*/React__default.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 14,
      columnNumber: 10
    }
  }, `${suggestion.name}`);
}
function getSuggestionsSchool(value, list) {
  if (!value) {
    return list;
  }

  value = value.toLowerCase();
  const filteredList = [];
  list.forEach(word => {
    if (word.name.toLowerCase().includes(value)) {
      filteredList.push(word);
    }
  });
  return filteredList;
} // section

function getSuggestionValueSection(suggestion) {
  return suggestion.name;
}
function renderSuggestionSection(suggestion) {
  return /*#__PURE__*/React__default.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 39,
      columnNumber: 10
    }
  }, `${suggestion.name}`);
}
function getSuggestionsSection(value, list) {
  if (!value) {
    return list;
  }

  const escapedValue = escapeRegexCharacters(value.trim());
  const regex = new RegExp(`^${escapedValue}`, 'i');
  return list.filter(item => regex.test(item.name));
} // blood group

function getSuggestionValueBloodGroup(suggestion) {
  return suggestion.value;
}
function renderSuggestionBloodGroup(suggestion) {
  return /*#__PURE__*/React__default.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 59,
      columnNumber: 10
    }
  }, `${suggestion.value}`);
}
function getSuggestionsBloodGroup(value, list) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return list;
  }

  const regex = new RegExp(`^${escapedValue}`, 'i');
  return list.filter(item => regex.test(item.value));
} // daily limit

var BLOOD_GROUP_LIST = [
	"A+",
	"A-",
	"B+",
	"B-",
	"O+",
	"O-",
	"AB+",
	"AB-"
];

var _jsxFileName$D = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildPhysical/SignupAddChildPhysical.js";
class SignupAddChildPhysicalBase extends Component {
  constructor(props) {
    super(props);

    this.enterListener = event => {
      event.preventDefault();

      if (event.keyCode === 13 && event.target.className.indexOf('react-autosuggest__input') < -1) {
        this.onClickSubmit();
      }
    };

    this.validationChangeHandler = (id, value) => {
      const {
        validation
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy[id] = value;
      this.setState({
        validation: validationCopy
      });
    };

    this.validationOnClickHandler = () => {
      const {
        validation,
        inputvalue
      } = this.state;
      const validationCopy = { ...validation
      };

      if (inputvalue.bloodgroup) {
        const filterData = BLOOD_GROUP_LIST.filter(item => inputvalue.bloodgroup === item);

        if (!(filterData && filterData.length)) {
          validationCopy.bloodgroup = true;
        }
      }

      this.setState({
        validation: validationCopy
      });
      return validationCopy;
    };

    this.onClickSubmit = () => {
      const {
        onClickAddChildPhysical
      } = this.props;
      const validation = this.validationOnClickHandler();

      if (Object.keys(validation).every(k => {
        this.setState({
          currentFieldFocus: k
        });
        return !validation[k];
      })) {
        const {
          inputvalue
        } = this.state;
        onClickAddChildPhysical(inputvalue);
      }
    };

    this.onFocusInput = id => {
      this.setState({
        currentFieldFocus: id
      });
    };

    this.onChangeAutoSuggest = (id, value) => {
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy
      });
    };

    this.onChangeInput = e => {
      const {
        target
      } = e;
      const {
        id
      } = target;
      const {
        value
      } = target;
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy
      });
    };

    this.state = {
      validation: {},
      inputvalue: {
        bloodgroup: props.data && props.data.bloodgroup ? props.data.bloodgroup : '',
        height: props.data && props.data.height ? String(props.data.height) : '',
        weight: props.data && props.data.weight ? String(props.data.weight) : ''
      },
      currentFieldFocus: ''
    };
  }

  componentDidMount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].addEventListener('keyup', this.enterListener);
  }

  componentWillUnmount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].removeEventListener('keyup', this.enterListener);
  }

  render() {
    const {
      inputvalue,
      validation,
      currentFieldFocus
    } = this.state;
    const {
      isEditable,
      showbtnloader,
      t
    } = this.props;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "signup_title",
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 129,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: t('add_child'),
      description: t('add_child_physical_description'),
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 130,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "signup_input",
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 135,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "bloodgroup",
      label: t('blood_group'),
      type: "text",
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.bloodgroup,
      onChange: this.onChangeAutoSuggest,
      validation: validation.bloodgroup,
      validationChange: this.validationChangeHandler,
      onFocusInput: this.onFocusInput,
      suggestionList: BLOOD_GROUP_LIST.map(key => ({
        key,
        value: key
      })),
      getSuggestions: getSuggestionsBloodGroup,
      getSuggestionValue: getSuggestionValueBloodGroup,
      renderSuggestion: renderSuggestionBloodGroup,
      shouldRender: true,
      required: true,
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 136,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 156,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "height",
      label: t('height'),
      type: "text",
      number: true,
      value: inputvalue.height,
      onChange: this.onChangeInput,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 157,
        columnNumber: 13
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 168,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "weight",
      label: t('weight'),
      type: "text",
      number: true,
      value: inputvalue.weight,
      onChange: this.onChangeInput,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 169,
        columnNumber: 13
      }
    })), /*#__PURE__*/React__default.createElement(Button, {
      type: "block",
      text: isEditable ? t('save') : t('next'),
      size: "big",
      showloader: showbtnloader,
      onClick: this.onClickSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName$D,
        lineNumber: 180,
        columnNumber: 11
      }
    })));
  }

}
const SignupAddChildPhysical = withTranslation()(SignupAddChildPhysicalBase);
SignupAddChildPhysical.propTypes = {
  onClickAddChildPhysical: PropTypes.func
};
SignupAddChildPhysical.defaultProps = {
  onClickAddChildPhysical: () => {}
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildProfile/SignupAddChildProfile.scss");

var _jsxFileName$E = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildProfile/SignupAddChildProfile.js";
class SignupAddChildProfileBase extends Component {
  constructor(props) {
    super(props);

    this.enterListener = event => {
      event.preventDefault();

      if (event.keyCode === 13 && event.target.className.indexOf('react-autosuggest__input') < -1) {
        this.onClickSubmit();
      }
    };

    this.validationChangeHandler = (id, value) => {
      const {
        validation
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy[id] = value;
      this.setState({
        validation: validationCopy
      });
    };

    this.validationOnClickHandler = () => {
      const {
        validation,
        inputvalue,
        requireStudentId,
        showSection
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy.firstname = !HasValueValidation(inputvalue.firstname);
      validationCopy.lastname = !HasValueValidation(inputvalue.lastname);
      validationCopy.date_of_birth = !inputvalue.date_of_birth;
      validationCopy.school = !(inputvalue.schooluuid && inputvalue.school);
      validationCopy.grade = !(inputvalue.gradeuuid && inputvalue.grade);
      if (showSection) validationCopy.section = !(inputvalue.sectionuuid && inputvalue.section);
      if (requireStudentId) validationCopy.studentId = !inputvalue.studentId;else validationCopy.studentId = false;
      this.setState({
        validation: validationCopy
      });
      return validationCopy;
    };

    this.onClickSubmit = () => {
      const {
        onClickAddChildProfile
      } = this.props;
      const validation = this.validationOnClickHandler();

      if (Object.keys(validation).every(k => {
        this.setState({
          currentFieldFocus: k
        });
        return !validation[k];
      })) {
        const {
          inputvalue,
          requireStudentId
        } = this.state;
        if (!requireStudentId) delete inputvalue.studentId;
        onClickAddChildProfile(inputvalue);
      }
    };

    this.onChangeDatePicker = (id, value) => {
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy,
        currentFieldFocus: 'school'
      });
    };

    this.editValueSet = (id, data, uuid) => {
      const filteredData = data.filter(key => uuid === key.uuid);

      if (filteredData && filteredData.length) {
        const {
          inputvalue
        } = this.state;
        inputvalue[id] = filteredData[0].name;
        this.setState({
          inputvalue
        });
      }
    };

    this.validationChangeHandler = (id, value) => {
      const {
        validation
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy[id] = value;
      this.setState({
        validation: validationCopy
      });
    };

    this.onFocusInput = id => {
      this.setState({
        currentFieldFocus: id
      });
    };

    this.onChangeAutoSuggestion = (id, value, suggestionList) => {
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      const {
        clearGradeSectionValue
      } = this.props;

      if (suggestionList && suggestionList.uuid) {
        const {
          getAddChildGradeData,
          getAddChildSectionData
        } = this.props;
        const uuidID = `${id}uuid`;
        const uuidValue = suggestionList.uuid;
        valueCopy[uuidID] = uuidValue;

        if (id === 'school') {
          valueCopy.grade = '';
          valueCopy.gradeuuid = '';
          valueCopy.section = '';
          valueCopy.sectionuuid = '';
          this.setState({
            requireStudentId: suggestionList.require_student_id
          });
          clearGradeSectionValue();
          getAddChildGradeData(suggestionList.uuid);
        }

        if (id === 'grade') {
          valueCopy.section = '';
          valueCopy.sectionuuid = '';
          this.setState({
            showSection: suggestionList.has_section
          });
          getAddChildSectionData(suggestionList.uuid);
        }
      } else if (value === '' && id === 'school') {
        valueCopy.grade = '';
        valueCopy.gradeuuid = '';
        valueCopy.section = '';
        valueCopy.sectionuuid = '';
        valueCopy.schooluuid = '';
        clearGradeSectionValue();
      } else if (value === '' && id === 'grade') {
        valueCopy.grade = '';
        valueCopy.gradeuuid = '';
        valueCopy.section = '';
        valueCopy.sectionuuid = '';
      } else if (!(suggestionList && suggestionList.uuid)) {
        const uuidID = `${id}uuid`;
        valueCopy[uuidID] = '';
      }

      this.setState({
        inputvalue: valueCopy
      });
    };

    this.onChangeInput = e => {
      const {
        id,
        value
      } = e.target;
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy
      });
    };

    this.state = {
      validation: {
        firstname: false,
        lastname: false,
        date_of_birth: false
      },
      inputvalue: {
        firstname: props.data && props.data.firstname || '',
        lastname: props.data && props.data.lastname || '',
        date_of_birth: props.data && props.data.date_of_birth ? props.data.date_of_birth : null,
        school: props.data && props.data.school ? props.data.school : '',
        schooluuid: props.data && props.data.schooluuid,
        gradeuuid: props.data && props.data.gradeuuid,
        grade: props.data && props.data.grade ? props.data.grade : '',
        studentId: props.data && props.data.studentId ? props.data.studentId : '',
        section: props.data && props.data.section ? props.data.section : '',
        sectionuuid: props.data && props.data.sectionuuid
      },
      currentFieldFocus: 'firstname',
      requireStudentId: props.data && props.data.studentId || false,
      showSection: props.data && props.data.sectionuuid || false
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      addChildSchoolList,
      addChildGradeList,
      addChildSectionList
    } = this.props;

    if (nextProps.isEditable && nextProps.addChildSchoolList && nextProps.addChildSchoolList !== addChildSchoolList && nextProps.addChildSchoolList.length) {
      if (nextProps.data && nextProps.data.schooluuid) this.editValueSet('school', nextProps.addChildSchoolList, nextProps.data.schooluuid);
    }

    if (nextProps.isEditable && nextProps.addChildGradeList && nextProps.addChildGradeList !== addChildGradeList && nextProps.addChildGradeList.length) {
      if (nextProps.data && nextProps.data.gradeuuid) this.editValueSet('grade', nextProps.addChildGradeList, nextProps.data.gradeuuid);
    }

    if (nextProps.isEditable && nextProps.addChildSectionList && nextProps.addChildSectionList !== addChildSectionList && nextProps.addChildSectionList.length) {
      if (nextProps.data && nextProps.data.sectionuuid) this.editValueSet('section', nextProps.addChildSectionList, nextProps.data.sectionuuid);
    }
  }

  render() {
    const {
      inputvalue,
      validation,
      currentFieldFocus
    } = this.state;
    const {
      isEditable,
      showbtnloader,
      t
    } = this.props;
    const {
      requireStudentId,
      showSection
    } = this.state;
    const {
      addChildSchoolList,
      addChildGradeList,
      addChildSectionList
    } = this.props;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "signup_title",
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 243,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: t('add_child'),
      description: t('add_child_profile_description'),
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 244,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "signup_input",
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 249,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "firstname",
      label: t('first_name'),
      type: "text",
      required: true,
      value: inputvalue.firstname,
      onChange: this.onChangeInput,
      validation: validation.firstname,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 250,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "lastname",
      label: t('last_name'),
      type: "text",
      required: true,
      value: inputvalue.lastname,
      onChange: this.onChangeInput,
      validation: validation.lastname,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 262,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(DatePicker, {
      id: "date_of_birth",
      label: t('date_of_birth'),
      required: true,
      value: inputvalue.date_of_birth,
      onChange: this.onChangeDatePicker,
      validation: validation.date_of_birth,
      maxDate: Date.now(),
      dateFormat: "dd-MMM-yyyy",
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 274,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "school",
      label: t('school'),
      type: "text",
      required: true,
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.school,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildSchoolList,
      validation: validation.school,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSchool,
      getSuggestionValue: getSuggestionValueSchool,
      renderSuggestion: renderSuggestionSchool,
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 287,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "grade",
      label: t('grade'),
      type: "text",
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.grade,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildGradeList,
      validation: validation.grade,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSchool,
      getSuggestionValue: getSuggestionValueSchool,
      renderSuggestion: renderSuggestionSchool,
      disabled: !(addChildGradeList && addChildGradeList.length),
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 303,
        columnNumber: 11
      }
    }), showSection && /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "section",
      label: t('section'),
      type: "text",
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.section,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildSectionList,
      validation: validation.section,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSection,
      getSuggestionValue: getSuggestionValueSection,
      renderSuggestion: renderSuggestionSection,
      disabled: !(addChildSectionList && addChildSectionList.length),
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 321,
        columnNumber: 13
      }
    }), requireStudentId && /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "studentId",
      type: "text",
      text: true,
      label: t('student_school_card_id'),
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.studentId,
      onChange: this.onChangeInput,
      onFocus: this.onFocusInput,
      disabled: !requireStudentId,
      validation: validation.studentId,
      validationChange: this.validationChangeHandler,
      validationMessage: requireStudentId ? 'Please make sure the card number matches your GEMS or STS card number' : '',
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 340,
        columnNumber: 13
      }
    }), /*#__PURE__*/React__default.createElement(Button, {
      type: "block",
      text: isEditable ? t('save') : t('next'),
      size: "big",
      onClick: this.onClickSubmit,
      showloader: showbtnloader,
      __self: this,
      __source: {
        fileName: _jsxFileName$E,
        lineNumber: 360,
        columnNumber: 11
      }
    })));
  }

}
const SignupAddChildProfile = withTranslation()(SignupAddChildProfileBase);
SignupAddChildProfile.propTypes = {
  onClickAddChildProfile: PropTypes.func
};
SignupAddChildProfile.defaultProps = {
  onClickAddChildProfile: () => {}
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildSchool/SignupAddChildSchool.scss");

var _jsxFileName$F = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildSchool/SignupAddChildSchool.js";
class SignupAddChildSchoolBase extends Component {
  constructor(props) {
    super(props);

    this.editValueSet = (id, data, uuid) => {
      const filteredData = data.filter(key => uuid === key.uuid);

      if (filteredData && filteredData.length) {
        const {
          inputvalue
        } = this.state;
        inputvalue[id] = filteredData[0].name;
        this.setState({
          inputvalue
        });
      }
    };

    this.enterListener = event => {
      event.preventDefault();

      if (event.keyCode === 13 && event.target.className.indexOf('react-autosuggest__input') < -1) {
        this.onClickSubmit();
      }
    };

    this.validationChangeHandler = (id, value) => {
      const {
        validation
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy[id] = value;
      this.setState({
        validation: validationCopy
      });
    };

    this.validationOnClickHandler = () => {
      const {
        validation,
        inputvalue,
        requireStudentId,
        showSection
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy.school = !(inputvalue.schooluuid && inputvalue.school);
      validationCopy.grade = !(inputvalue.gradeuuid && inputvalue.grade);
      if (showSection) validationCopy.section = !(inputvalue.sectionuuid && inputvalue.section);
      if (requireStudentId) validationCopy.studentId = !inputvalue.studentId;else validationCopy.studentId = false;
      this.setState({
        validation: validationCopy
      });
      return validationCopy;
    };

    this.onClickSubmit = () => {
      const {
        onClickAddChildSchool
      } = this.props;
      const validation = this.validationOnClickHandler();

      if (Object.keys(validation).every(k => {
        this.setState({
          currentFieldFocus: k
        });
        return !validation[k];
      })) {
        const {
          inputvalue,
          requireStudentId
        } = this.state;
        if (!requireStudentId) delete inputvalue.studentId;
        onClickAddChildSchool(inputvalue);
      }
    };

    this.onFocusInput = id => {
      this.setState({
        currentFieldFocus: id
      });
    };

    this.onChangeAutoSuggestion = (id, value, suggestionList) => {
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      const {
        clearGradeSectionValue
      } = this.props;

      if (suggestionList && suggestionList.uuid) {
        const {
          getAddChildGradeData,
          getAddChildSectionData
        } = this.props;
        const uuidID = `${id}uuid`;
        const uuidValue = suggestionList.uuid;
        valueCopy[uuidID] = uuidValue;

        if (id === 'school') {
          valueCopy.grade = '';
          valueCopy.gradeuuid = '';
          valueCopy.section = '';
          valueCopy.sectionuuid = '';
          this.setState({
            requireStudentId: suggestionList.require_student_id
          });
          clearGradeSectionValue();
          getAddChildGradeData(suggestionList.uuid);
        }

        if (id === 'grade') {
          valueCopy.section = '';
          valueCopy.sectionuuid = '';
          this.setState({
            showSection: suggestionList.has_section
          });
          getAddChildSectionData(suggestionList.uuid);
        }
      } else if (value === '' && id === 'school') {
        valueCopy.grade = '';
        valueCopy.gradeuuid = '';
        valueCopy.section = '';
        valueCopy.sectionuuid = '';
        valueCopy.schooluuid = '';
        clearGradeSectionValue();
      } else if (value === '' && id === 'grade') {
        valueCopy.grade = '';
        valueCopy.gradeuuid = '';
        valueCopy.section = '';
        valueCopy.sectionuuid = '';
      } else if (!(suggestionList && suggestionList.uuid)) {
        const uuidID = `${id}uuid`;
        valueCopy[uuidID] = '';
      }

      this.setState({
        inputvalue: valueCopy
      });
    };

    this.onChangeInput = e => {
      const {
        target
      } = e;
      const {
        id
      } = target;
      const {
        value
      } = target;
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy
      });
    };

    this.state = {
      validation: {
        school: false,
        grade: false,
        section: false,
        studentId: false
      },
      inputvalue: {
        school: props.data && props.data.school ? props.data.school : '',
        schooluuid: props.data && props.data.schooluuid,
        gradeuuid: props.data && props.data.gradeuuid,
        grade: props.data && props.data.grade ? props.data.grade : '',
        studentId: props.data && props.data.studentId ? props.data.studentId : '',
        section: props.data && props.data.section ? props.data.section : '',
        sectionuuid: props.data && props.data.sectionuuid
      },
      currentFieldFocus: '',
      requireStudentId: props.data && props.data.studentId && props.data.studentId || false,
      showSection: props.data && props.data.sectionuuid || false
    };
  }

  componentDidMount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].addEventListener('keyup', this.enterListener);
  }

  componentWillReceiveProps(nextProps) {
    const {
      addChildSchoolList,
      addChildGradeList,
      addChildSectionList
    } = this.props;

    if (nextProps.isEditable && nextProps.addChildSchoolList && nextProps.addChildSchoolList !== addChildSchoolList && nextProps.addChildSchoolList.length) {
      if (nextProps.data && nextProps.data.schooluuid) this.editValueSet('school', nextProps.addChildSchoolList, nextProps.data.schooluuid);
    }

    if (nextProps.isEditable && nextProps.addChildGradeList && nextProps.addChildGradeList !== addChildGradeList && nextProps.addChildGradeList.length) {
      if (nextProps.data && nextProps.data.gradeuuid) this.editValueSet('grade', nextProps.addChildGradeList, nextProps.data.gradeuuid);
    }

    if (nextProps.isEditable && nextProps.addChildSectionList && nextProps.addChildSectionList !== addChildSectionList && nextProps.addChildSectionList.length) {
      if (nextProps.data && nextProps.data.sectionuuid) this.editValueSet('section', nextProps.addChildSectionList, nextProps.data.sectionuuid);
    }
  }

  componentWillUnmount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].removeEventListener('keyup', this.enterListener);
  }

  render() {
    const {
      inputvalue,
      validation,
      currentFieldFocus,
      requireStudentId,
      showSection
    } = this.state;
    const {
      addChildSchoolList,
      addChildGradeList,
      addChildSectionList,
      isEditable,
      showbtnloader,
      t
    } = this.props;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "signup_title",
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 248,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: t('add_child'),
      description: t('add_Child_school_description'),
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 249,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "signup_input",
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 254,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "school",
      label: t('school'),
      type: "text",
      required: true,
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.school,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildSchoolList,
      validation: validation.school,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSchool,
      getSuggestionValue: getSuggestionValueSchool,
      renderSuggestion: renderSuggestionSchool,
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 255,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "grade",
      label: t('grade'),
      type: "text",
      required: true,
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.grade,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildGradeList,
      validation: validation.grade,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSchool,
      getSuggestionValue: getSuggestionValueSchool,
      renderSuggestion: renderSuggestionSchool,
      disabled: !(addChildGradeList && addChildGradeList.length),
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 271,
        columnNumber: 11
      }
    }), showSection && /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "section",
      label: t('section'),
      type: "text",
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.section,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: addChildSectionList,
      validation: validation.section,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSection,
      getSuggestionValue: getSuggestionValueSection,
      renderSuggestion: renderSuggestionSection,
      disabled: !(addChildSectionList && addChildSectionList.length),
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 289,
        columnNumber: 13
      }
    }), requireStudentId && /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "studentId",
      type: "text",
      required: true,
      text: true,
      label: t('student_school_card_id'),
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.studentId,
      onChange: this.onChangeInput,
      onFocus: this.onFocusInput,
      disabled: !requireStudentId,
      validation: validation.studentId,
      validationChange: this.validationChangeHandler,
      validationMessage: requireStudentId ? 'Please make sure the card number matches your GEMS or STS card number' : '',
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 308,
        columnNumber: 13
      }
    }), /*#__PURE__*/React__default.createElement(Button, {
      type: "block",
      text: isEditable ? t('save') : t('next'),
      size: "big",
      showloader: showbtnloader,
      onClick: this.onClickSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName$F,
        lineNumber: 329,
        columnNumber: 11
      }
    })));
  }

}
const SignupAddChildSchool = withTranslation()(SignupAddChildSchoolBase);
SignupAddChildSchool.propTypes = {
  onClickAddChildSchool: PropTypes.func,
  addChildSchoolList: PropTypes.arrayOf(PropTypes.shape({})),
  clearGradeSectionValue: PropTypes.func
};
SignupAddChildSchool.defaultProps = {
  onClickAddChildSchool: () => {},
  addChildSchoolList: [],
  clearGradeSectionValue: () => {}
};

/* loaded by smart-asset */
require("../src/components/SignupAddChildSuccess/SignupAddChildSuccess.scss");

var _jsxFileName$G = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupAddChildSuccess/SignupAddChildSuccess.js";
const SignupAddChildSuccess = props => {
  const {
    addChildData,
    continueToChildrenClick,
    topupChildren
  } = props;
  const {
    t
  } = useTranslation();
  const name = addChildData && addChildData.first_name;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "signup_success",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "signup_success_image",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 18,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: CompleteDesktopIcon,
    alt: "complete",
    className: "signup_success_image_desktop",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 19,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: CompleteMobileIcon,
    alt: "complete",
    className: "signup_success_image_mobile",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 24,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "signup_success_text",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 30,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: `${t('add_child_success_title_1')} ${name} ${t('add_child_success_title_2')}`,
    description: `${t('add_child_success_description_1')} ${name} ${t('add_child_success_description_2')}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 31,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "signup_success_button",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 40,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: t('top_up'),
    type: "block",
    size: "big",
    onClick: topupChildren,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 41,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "signup_success_button",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 48,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: t('continue_to_list_of_children'),
    type: "block",
    size: "big",
    onClick: continueToChildrenClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 49,
      columnNumber: 9
    }
  })));
  return Dom;
};

/* loaded by smart-asset */
require("../src/components/SignupCreateAccount/SignupCreateAccount.scss");

var _jsxFileName$H = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/SignupCreateAccount/SignupCreateAccount.js";
class SignupCreateAccountBase extends Component {
  constructor(props) {
    super(props);

    this.enterListener = event => {
      event.preventDefault();

      if (event.keyCode === 13) {
        this.onClickSubmit();
      }
    };

    this.validationChangeHandler = (id, value) => {
      const {
        validation
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy[id] = value;
      this.setState({
        validation: validationCopy
      });
    };

    this.validationOnClickHandler = () => {
      const {
        validation,
        inputvalue,
        isFaculty
      } = this.state;
      const validationCopy = { ...validation
      };
      validationCopy.firstname = !HasValueValidation(inputvalue.firstname);
      validationCopy.lastname = !HasValueValidation(inputvalue.lastname);
      validationCopy.email = !EmailValidation(inputvalue.email);
      validationCopy.mobile = !PhoneNumberValidation(inputvalue.mobile);
      validationCopy.passwordHasValue = !HasValueValidation(inputvalue.password);
      validationCopy.password = !PasswordValidation(inputvalue.password);

      if (isFaculty) {
        validationCopy.cardId = !HasValueValidation(inputvalue.cardId);
        validationCopy.school = !HasValueValidation(inputvalue.schooluuid && inputvalue.school);
      }

      this.setState({
        validation: validationCopy
      });
      return validationCopy;
    };

    this.validationAlert = key => {
      const {
        alert
      } = this.props;

      if (key === 'email') {
        alert({
          type: 'error',
          content: 'Please enter vaild email'
        });
      } else if (key === 'mobile') {
        alert({
          type: 'error',
          content: 'Please enter valid mobile number'
        });
      } else if (key === 'password') {
        alert({
          type: 'error',
          content: 'Password must be a combination of upper case, lower case, and number'
        });
      } else if (key === 'passwordHasValue') {
        alert({
          type: 'error',
          content: 'Please enter password'
        });
      }
    };

    this.onClickSubmit = () => {
      const {
        onClickCreateAccount
      } = this.props;
      const validation = this.validationOnClickHandler();

      if (Object.keys(validation).every(k => {
        this.setState({
          currentFieldFocus: k
        });
        if (validation[k]) this.validationAlert(k);
        return !validation[k];
      })) {
        const {
          inputvalue,
          referralCode,
          isFaculty
        } = this.state;
        const payload = {
          password: inputvalue.password,
          first_name: inputvalue.firstname,
          last_name: inputvalue.lastname,
          phone_no: Number(inputvalue.mobile),
          email: inputvalue.email.toLowerCase(),
          role: isFaculty ? 'FACULTY' : 'PARENT'
        };

        if (isFaculty) {
          payload.school_uuid = inputvalue.schooluuid;
          payload.card_id = inputvalue.cardId;
        }

        if (referralCode) {
          payload.referral_code = referralCode;
        }

        onClickCreateAccount(payload);
      }
    };

    this.onFocusInput = id => {
      this.setState({
        currentFieldFocus: id
      });
    };

    this.onChangeInput = e => {
      const {
        target
      } = e;
      const {
        id
      } = target;
      const {
        value
      } = target;
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;
      this.setState({
        inputvalue: valueCopy
      });
    };

    this.facultyClickHandler = () => {
      this.setState({
        isFaculty: true
      });
      const {
        onFacultyChange
      } = this.props;
      onFacultyChange();
    };

    this.onChangeAutoSuggestion = (id, value, suggestionList) => {
      const {
        inputvalue
      } = this.state;
      const valueCopy = { ...inputvalue
      };
      valueCopy[id] = value;

      if (suggestionList && suggestionList.uuid) {
        const uuidID = `${id}uuid`;
        const uuidValue = suggestionList.uuid;
        valueCopy[uuidID] = uuidValue;
      }

      this.setState({
        inputvalue: valueCopy
      });
    };

    this.state = {
      validation: {
        firstname: false,
        lastname: false,
        email: false,
        mobile: false,
        password: false,
        school: false,
        cardId: false
      },
      inputvalue: {
        firstname: '',
        lastname: '',
        email: '',
        mobile: '',
        password: '',
        school: '',
        schooluuid: '',
        cardId: ''
      },
      referralCode: props.referralCode,
      currentFieldFocus: 'firstname',
      isFaculty: false
    };
  }

  componentDidMount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].addEventListener('keyup', this.enterListener);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.referralCode) {
      this.setState({
        referralCode: nextProps.referralCode
      });
    }
  }

  componentWillUnmount() {
    if (document && document.getElementsByClassName('signup_input') && document.getElementsByClassName('signup_input')[0]) document.getElementsByClassName('signup_input')[0].removeEventListener('keyup', this.enterListener);
  }

  render() {
    const {
      inputvalue,
      validation,
      currentFieldFocus,
      referralCode,
      isFaculty
    } = this.state;
    const {
      showloader,
      t,
      schoolList
    } = this.props;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "signup_title",
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 206,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: t('create_an_account'),
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 207,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "signup_input",
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 209,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "firstname",
      label: t('first_name'),
      type: "text",
      required: true,
      value: inputvalue.firstname,
      onChange: this.onChangeInput,
      validation: validation.firstname,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 210,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "lastname",
      label: t('last_name'),
      type: "text",
      required: true,
      value: inputvalue.lastname,
      onChange: this.onChangeInput,
      validation: validation.lastname,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 222,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "email",
      label: t('email'),
      type: "email",
      required: true,
      value: inputvalue.email,
      onChange: this.onChangeInput,
      validation: validation.email,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 234,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "mobile",
      label: t('mobile'),
      type: "text",
      number: true,
      required: true,
      value: inputvalue.mobile,
      onChange: this.onChangeInput,
      validation: validation.mobile,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 246,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "password",
      label: t('password'),
      type: "password",
      required: true,
      value: inputvalue.password,
      onChange: this.onChangeInput,
      validation: validation.password,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 259,
        columnNumber: 11
      }
    }), referralCode && /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "referralCode",
      label: t('referral_code'),
      type: "text",
      disabled: true,
      value: referralCode,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 272,
        columnNumber: 13
      }
    }), isFaculty && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AutoSuggestion, {
      id: "school",
      label: t('school'),
      type: "text",
      required: true,
      currentFieldFocus: currentFieldFocus,
      value: inputvalue.school,
      onChange: this.onChangeAutoSuggestion,
      onFocus: this.onFocusInput,
      suggestionList: schoolList || [],
      validation: validation.school,
      validationChange: this.validationChangeHandler,
      getSuggestions: getSuggestionsSchool,
      getSuggestionValue: getSuggestionValueSchool,
      renderSuggestion: renderSuggestionSchool,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 283,
        columnNumber: 15
      }
    }), /*#__PURE__*/React__default.createElement(InputLabelFloat, {
      id: "cardId",
      label: t('cardId'),
      type: "text",
      required: true,
      value: inputvalue.cardId,
      onChange: this.onChangeInput,
      validation: validation.cardId,
      validationChange: this.validationChangeHandler,
      onFocus: this.onFocusInput,
      currentFieldFocus: currentFieldFocus,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 299,
        columnNumber: 15
      }
    })), /*#__PURE__*/React__default.createElement(Button, {
      type: "block",
      text: isFaculty ? 'SIGN UP AS FACULTY' : t('next_add_child'),
      size: "big",
      onClick: this.onClickSubmit,
      showloader: showloader,
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 314,
        columnNumber: 11
      }
    }), !isFaculty && /*#__PURE__*/React__default.createElement("div", {
      className: "signup_input_faculty",
      role: "presentation",
      onClick: () => this.facultyClickHandler(),
      __self: this,
      __source: {
        fileName: _jsxFileName$H,
        lineNumber: 323,
        columnNumber: 13
      }
    }, "Please click here to create an faculty account")));
  }

}
const SignupCreateAccount = withTranslation()(SignupCreateAccountBase);
SignupCreateAccount.propTypes = {
  onClickCreateAccount: PropTypes.func,
  onFacultyChange: PropTypes.func,
  alert: PropTypes.func,
  schoolList: PropTypes.arrayOf(PropTypes.shape({}))
};
SignupCreateAccount.defaultProps = {
  onClickCreateAccount: () => {},
  onFacultyChange: () => {},
  alert: () => {}
};

/* loaded by smart-asset */
require("../src/components/Table/Table.scss");

var _jsxFileName$I = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Table/Table.js";
const Table = props => {
  const {
    columns,
    data,
    tableSort,
    onRowClick,
    itemkey
  } = props;
  const {
    t
  } = useTranslation();
  const DOM = /*#__PURE__*/React__default.createElement("div", {
    className: "tables",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    key: "table",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 14,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    key: "table_head",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 15,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    className: "tables__row",
    key: "table_head_row",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 16,
      columnNumber: 11
    }
  }, columns.map(head => {
    return /*#__PURE__*/React__default.createElement("th", {
      className: head.head_classname,
      key: head.title,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$I,
        lineNumber: 19,
        columnNumber: 17
      }
    }, t(head.title), head.sort && /*#__PURE__*/React__default.createElement("img", {
      src: DownArrowSvg,
      role: "presentation",
      onClick: () => tableSort(head.key),
      className: `sortIcon ${head.sort === 'd-a' ? '' : 'rotate'}`,
      alt: "Downarrow",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$I,
        lineNumber: 22,
        columnNumber: 21
      }
    }));
  }))), /*#__PURE__*/React__default.createElement("tbody", {
    key: "table_body",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 37,
      columnNumber: 9
    }
  }, data && data.map((item, dataIndex) => {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement("tr", {
        key: `${item[itemkey]}${dataIndex}`,
        onClick: () => onRowClick(item),
        className: onRowClick && 'u_cursor_pointer',
        __self: undefined,
        __source: {
          fileName: _jsxFileName$I,
          lineNumber: 42,
          columnNumber: 17
        }
      }, columns.map((col, index) => {
        return /*#__PURE__*/React__default.createElement("td", {
          className: col.data_classname // eslint-disable-next-line react/no-array-index-key
          ,
          key: `${item[col.key]}${item[itemkey]}${index}`,
          __self: undefined,
          __source: {
            fileName: _jsxFileName$I,
            lineNumber: 49,
            columnNumber: 23
          }
        }, col.render ? col.render(item[col.key], item, index) : item[col.key]);
      }))
    );
  }))), !(data && data.length) && /*#__PURE__*/React__default.createElement("div", {
    className: "tables__nodata",
    key: "no-content",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 66,
      columnNumber: 9
    }
  }, t('no_data'), " !!"));
  return DOM;
};
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  tableSort: PropTypes.func,
  onRowClick: PropTypes.func,
  itemkey: PropTypes.string
};
Table.defaultProps = {
  columns: [],
  data: [],
  tableSort: () => {},
  onRowClick: () => {},
  itemkey: ''
};

/* loaded by smart-asset */
require("../src/components/Textarea/Textarea.scss");

var _jsxFileName$J = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Textarea/Textarea.js";
const Textarea = props => {
  const {
    title,
    onChange,
    value
  } = props;
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "textarea",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$J,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "textarea__title",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$J,
      lineNumber: 10,
      columnNumber: 7
    }
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "textarea__content",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$J,
      lineNumber: 11,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("textarea", {
    value: value,
    rows: "5",
    className: "textarea__content_box",
    onChange: onChange,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$J,
      lineNumber: 12,
      columnNumber: 9
    }
  })));
  return Dom;
};
Textarea.propTypes = {
  onChange: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.string
};
Textarea.defaultProps = {
  onChange: () => {},
  title: '',
  value: ''
};

/* loaded by smart-asset */
require("../src/components/ToggleButton/ToggleButton.scss");

var _jsxFileName$K = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ToggleButton/ToggleButton.js";
const ToggleButton = props => {
  const {
    name,
    id,
    label,
    onChange,
    disabled,
    checked,
    color
  } = props;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "toggle",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    className: "toggle__checkbox",
    id: id,
    onChange: onChange,
    disabled: disabled,
    checked: checked,
    name: name,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 10,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `${color} ${checked ? 'on' : 'off'}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `toggle_text ${checked ? 'on' : 'off'}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 20,
      columnNumber: 9
    }
  }, checked ? 'ON' : 'OFF'), label));
};
ToggleButton.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  color: PropTypes.string
};
ToggleButton.defaultProps = {
  id: '',
  label: '',
  onChange: null,
  disabled: false,
  checked: false,
  color: ''
};

/* loaded by smart-asset */
require("../src/components/ToggleSeverity/ToggleSeverity.scss");

var _jsxFileName$L = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ToggleSeverity/ToggleSeverity.js";
class ToggleSeverity extends Component {
  constructor(props) {
    super(props);

    this.onChange = e => {
      const {
        onAllergySelector,
        id
      } = this.props;
      let classToggle;

      if (e.target.classList.contains('active')) {
        classToggle = '';
      } else {
        classToggle = e.target.textContent;
      }

      this.setState({
        classToggle
      });
      onAllergySelector(id, classToggle);
    };

    this.state = {
      classToggle: ''
    };
  }

  componentDidMount() {
    const {
      severity
    } = this.props;
    this.setState({
      classToggle: severity
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      severity
    } = nextProps;
    this.setState({
      classToggle: severity
    });
  }

  render() {
    const {
      classToggle
    } = this.state;
    const {
      title,
      color
    } = this.props;
    const Dom = /*#__PURE__*/React__default.createElement("div", {
      className: "toggleSeverity",
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 40,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "toggleSeverity__title",
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 41,
        columnNumber: 9
      }
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "toggleSeverity__list",
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 42,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      onClick: e => this.onChange(e),
      role: "presentation",
      className: `toggleSeverity__list_item ${color} ${classToggle === 'MILD' ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 43,
        columnNumber: 11
      }
    }, "MILD"), /*#__PURE__*/React__default.createElement("div", {
      onClick: e => this.onChange(e),
      role: "presentation",
      className: `toggleSeverity__list_item ${color} ${classToggle === 'HIGH' ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 52,
        columnNumber: 11
      }
    }, "HIGH"), /*#__PURE__*/React__default.createElement("div", {
      onClick: e => this.onChange(e),
      role: "presentation",
      className: `toggleSeverity__list_item ${color} ${classToggle === 'SEVERE' ? 'active' : ''}`,
      __self: this,
      __source: {
        fileName: _jsxFileName$L,
        lineNumber: 61,
        columnNumber: 11
      }
    }, "SEVERE")));
    return Dom;
  }

}
ToggleSeverity.propTypes = {
  title: PropTypes.string
};
ToggleSeverity.defaultProps = {
  title: ''
};

/* loaded by smart-asset */
require("../src/components/ToggleTabs/ToggleTabs.scss");

var _jsxFileName$M = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/ToggleTabs/ToggleTabs.js";
const ToggleTabs = props => {
  const {
    data,
    onClick,
    id
  } = props;
  let {
    headingText
  } = props;
  let postfixName = '';

  if (id === 'delivery' && window.innerWidth >= 768) {
    headingText = 'Delivery';
    postfixName = ' / week';
  }

  const listDom = data.map(item => {
    return /*#__PURE__*/React__default.createElement("li", {
      key: `${item.key}`,
      className: `toggleTabs_list_item ${item.status}`,
      role: "presentation",
      onClick: () => onClick(item),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$M,
        lineNumber: 16,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "toggleTabs_list_item_text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$M,
        lineNumber: 22,
        columnNumber: 9
      }
    }, item.displayName, postfixName, item.status && /*#__PURE__*/React__default.createElement("div", {
      className: "selected",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$M,
        lineNumber: 25,
        columnNumber: 27
      }
    }, "selected")));
  });
  const Dom = /*#__PURE__*/React__default.createElement("div", {
    className: "toggleTabs",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$M,
      lineNumber: 32,
      columnNumber: 5
    }
  }, headingText && /*#__PURE__*/React__default.createElement("div", {
    className: "toggleTabs_heading",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$M,
      lineNumber: 33,
      columnNumber: 23
    }
  }, headingText), /*#__PURE__*/React__default.createElement("ul", {
    className: "u_list_style_none toggleTabs_list",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$M,
      lineNumber: 34,
      columnNumber: 7
    }
  }, listDom));
  return Dom;
};
ToggleTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    displayName: PropTypes.string,
    index: PropTypes.number
  })),
  onClick: PropTypes.func,
  headingText: PropTypes.string,
  id: PropTypes.string
};
ToggleTabs.defaultProps = {
  data: [],
  headingText: '',
  onClick: () => {},
  id: ''
};

/* loaded by smart-asset */
require("../src/components/Tooltip/Tooltip.scss");

var _jsxFileName$N = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/Tooltip/Tooltip.js";
class Tooltip extends React__default.Component {
  constructor() {
    super();

    this.onClickItem = (path, onClick) => {
      // FIXME: This needs refactoring
      const {
        history,
        apiData
      } = this.props;
      if (onClick) onClick(path, apiData);else history.push(path);
    };

    this.isContentToBeRendered = data => {
      // FIXME: This needs refactoring
      const {
        apiData
      } = this.props;

      if (data.key === 'report_lost') {
        if (!apiData.allow_classroom_delivery) {
          return true;
        }

        return false;
      }

      if (data.key === 'menu') {
        if (apiData.allow_classroom_delivery) {
          return true;
        }

        return false;
      }

      return true;
    };

    this.showDropdownMenu = event => {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        displayMenu: true
      }, () => {
        document.addEventListener('click', this.hideDropdownMenu);
      });
    };

    this.hideDropdownMenu = ({
      path
    }) => {
      if (path.includes(this.menuNodeRef.current)) {
        return;
      }

      this.setState({
        displayMenu: false
      }, () => {
        document.removeEventListener('click', this.hideDropdownMenu);
      });
    };

    this.state = {
      displayMenu: false
    };
    this.menuNodeRef = React__default.createRef();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideDropdownMenu);
  }

  render() {
    const {
      displayMenu
    } = this.state;
    const {
      children,
      listData,
      position
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "tooltip",
      __self: this,
      __source: {
        fileName: _jsxFileName$N,
        lineNumber: 65,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "tooltip_children",
      role: "presentation",
      onClick: this.showDropdownMenu,
      __self: this,
      __source: {
        fileName: _jsxFileName$N,
        lineNumber: 66,
        columnNumber: 9
      }
    }, children), displayMenu && /*#__PURE__*/React__default.createElement("ul", {
      className: `tooltip_list ${position}`,
      ref: this.menuNodeRef,
      __self: this,
      __source: {
        fileName: _jsxFileName$N,
        lineNumber: 74,
        columnNumber: 11
      }
    }, listData && listData.map(data => {
      const {
        key,
        text,
        isDisabled
      } = data;
      return this.isContentToBeRendered(data) ? /*#__PURE__*/React__default.createElement("li", {
        key: key,
        className: 'tooltip_list_item' + (isDisabled ? ' tooltip_list_item--disabled' : ''),
        __self: this,
        __source: {
          fileName: _jsxFileName$N,
          lineNumber: 79,
          columnNumber: 19
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        role: "presentation",
        onClick: isDisabled ? undefined : () => this.onClickItem(data.route, data.onClick),
        __self: this,
        __source: {
          fileName: _jsxFileName$N,
          lineNumber: 86,
          columnNumber: 21
        }
      }, text)) : '';
    })));
  }

}

/* loaded by smart-asset */
require("../src/components/TopupAmount/TopupAmount.scss");

var _jsxFileName$O = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/TopupAmount/TopupAmount.js";
const TopupAmount = props => {
  const {
    showCardLoader,
    paybtnshowloader,
    showCustomAmount,
    customAmount,
    currentFieldFocus,
    balanceText,
    balanceValue,
    paymentCardValue,
    name,
    customAmountChange,
    saveCustomAmountClick,
    customAmountClick,
    onFocusCustomAmount,
    onClickPaymentCard
  } = props;
  const {
    t
  } = useTranslation();
  const paymentCardDom = [];

  if (paymentCardValue && paymentCardValue.length) {
    paymentCardDom.push(paymentCardValue.map(data => {
      return /*#__PURE__*/React__default.createElement(PaymentCard, {
        onClick: () => onClickPaymentCard(data.amount, 'card'),
        key: data.mainText,
        mainText: data.mainText,
        subText: data.subText,
        __self: undefined,
        __source: {
          fileName: _jsxFileName$O,
          lineNumber: 39,
          columnNumber: 11
        }
      });
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "topup",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(TitleDescription, {
    title: t('top_up'),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 52,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "topup__card",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 53,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "topup__card_balance",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 54,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(LimitCard, {
    mainText: balanceText,
    subText: `${LocalStorage.getCurrency()} ${balanceValue}`,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 55,
      columnNumber: 11
    }
  })), showCardLoader ? /*#__PURE__*/React__default.createElement("div", {
    className: "topup_loader",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 61,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Loader, {
    fitContent: "full",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 62,
      columnNumber: 13
    }
  })) : paymentCardDom, name && /*#__PURE__*/React__default.createElement("div", {
    className: "topup__card_calc",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 68,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Trans, {
    i18nKey: "child_topup_expenditure",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 69,
      columnNumber: 13
    }
  }, {
    name
  })), showCustomAmount && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputLabelFloat, {
    id: "customAmount",
    type: "text",
    label: `${t('amount')} (${LocalStorage.getCurrency()})`,
    number: true,
    value: customAmount,
    onFocus: onFocusCustomAmount,
    currentFieldFocus: currentFieldFocus,
    onChange: customAmountChange,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 74,
      columnNumber: 13
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    showloader: paybtnshowloader,
    text: t('pay'),
    size: "big",
    type: "block",
    onClick: saveCustomAmountClick,
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 84,
      columnNumber: 13
    }
  }))), !showCustomAmount && !showCardLoader && /*#__PURE__*/React__default.createElement("div", {
    className: "topup__btn",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 95,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    text: t('custom_amount'),
    size: "big",
    type: "block",
    onClick: () => customAmountClick(),
    __self: undefined,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 96,
      columnNumber: 11
    }
  })));
};
TopupAmount.propTypes = {
  showCustomAmount: PropTypes.bool,
  customAmount: PropTypes.string,
  currentFieldFocus: PropTypes.string,
  balanceText: PropTypes.string,
  name: PropTypes.string,
  balanceValue: PropTypes.number,
  paymentCardValue: PropTypes.arrayOf(PropTypes.shape({})),
  customAmountChange: PropTypes.func,
  saveCustomAmountClick: PropTypes.func,
  customAmountClick: PropTypes.func,
  onFocusCustomAmount: PropTypes.func,
  onClickPaymentCard: PropTypes.func,
  paybtnshowloader: PropTypes.bool,
  showCardLoader: PropTypes.bool
};
TopupAmount.defaultProps = {
  showCustomAmount: false,
  customAmount: '',
  currentFieldFocus: '',
  balanceText: '',
  balanceValue: 0,
  name: '',
  paymentCardValue: [],
  customAmountChange: () => {},
  saveCustomAmountClick: () => {},
  customAmountClick: () => {},
  onFocusCustomAmount: () => {},
  onClickPaymentCard: () => {},
  paybtnshowloader: false,
  showCardLoader: false
};

/* loaded by smart-asset */
require("../src/components/TopupSuccess/TopupSuccess.scss");

var _jsxFileName$P = "/Users/n3tn0de/Projects/YACOB/yacob-components/src/components/TopupSuccess/TopupSuccess.js";
const TopupSuccess = props => {
  const {
    data,
    cardText,
    showButton,
    successonClick,
    // childrenTopupList, onClickChildrenCard,
    balance,
    name,
    tryagainClick
  } = props;
  const {
    t
  } = useTranslation();
  let Dom = null;
  const currency = LocalStorage.getCurrency();
  const amount = data && data.amount;
  const customname = name ? `${name}'s` : t('your');

  if (data && data.status === 'SUCCESS') {
    const successText = `${t('topup_success_text_thankyou')}${currency} ${amount}${t('topup_success_text_added')}${customname} ${t('topup_success_text_balance')}`;
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image success",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 44,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CompleteDesktopIcon,
      alt: "complete",
      className: "topupSuccess__image_desktop",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 45,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("img", {
      src: CompleteMobileIcon,
      alt: "complete",
      className: "topupSuccess__image_mobile",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 50,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 56,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: successText,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 57,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__card",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 59,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(LimitCard, {
      mainText: cardText,
      subText: `${LocalStorage.getCurrency()} ${balance}`,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 60,
        columnNumber: 11
      }
    }), showButton ? /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 65,
        columnNumber: 13
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: t('continue'),
      size: "big",
      type: "block",
      onClick: successonClick,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 66,
        columnNumber: 15
      }
    })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button, {
      className: "u_margin_2rem_top_bot",
      text: t('continue_to_list_of_children'),
      size: "big",
      type: "block",
      onClick: successonClick,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 75,
        columnNumber: 15
      }
    }))));
  } else if (data && data.status === 'IN_PROGRESS') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image inprogress",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 94,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CircleIcon,
      alt: "circle",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 95,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image_inprogress",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 96,
        columnNumber: 11
      }
    }, /*#__PURE__*/React__default.createElement(Loader, {
      filtContent: "full",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 97,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 100,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: "Your payment is in progress\u2026",
      description: data.api_result || '',
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 101,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 106,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: t('continue'),
      size: "big",
      type: "block",
      onClick: successonClick,
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 107,
        columnNumber: 11
      }
    })));
  } else if (data && data.status === 'FAILED') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image failed",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 119,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CircleIcon,
      alt: "circle",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 120,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image_error",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 121,
        columnNumber: 11
      }
    }, "!")), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 123,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: data.status,
      description: data.api_result || '',
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 124,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 129,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: "Try Again",
      size: "big",
      type: "block",
      color: "lightgrey",
      onClick: () => tryagainClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 130,
        columnNumber: 11
      }
    })));
  } else if (data && data.status === 'REFUND_COMPLETED') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image refund_completed",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 143,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CompleteDesktopIcon,
      alt: "complete",
      className: "topupSuccess__image_desktop",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 144,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("img", {
      src: CompleteMobileIcon,
      alt: "complete",
      className: "topupSuccess__image_mobile",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 149,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 155,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: "REFUND COMPLETED",
      description: data.api_result || '',
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 156,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 161,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: t('continue'),
      size: "big",
      type: "block",
      onClick: () => successonClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 162,
        columnNumber: 11
      }
    })));
  } else if (data && data.status === 'PAYMENT_INITIATED') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image payment_initiated",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 174,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CircleIcon,
      alt: "circle",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 175,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image_initiated",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 176,
        columnNumber: 11
      }
    }, "!")), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 178,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: "Payment Initiated",
      description: data.api_result || '',
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 179,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 184,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: t('continue'),
      size: "big",
      type: "block",
      color: "lightgrey",
      onClick: () => successonClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 185,
        columnNumber: 11
      }
    })));
  } else if (data && data.status === 'REFUND_INITIATED') {
    Dom = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image refund_initiated",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 198,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: CircleIcon,
      alt: "circle",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 199,
        columnNumber: 11
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__image_initiated",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 200,
        columnNumber: 11
      }
    }, "!")), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__text",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 202,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(TitleDescription, {
      title: "Refund Initiated",
      description: data.api_result || '',
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 203,
        columnNumber: 11
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "topupSuccess__btn",
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 208,
        columnNumber: 9
      }
    }, /*#__PURE__*/React__default.createElement(Button, {
      text: t('continue'),
      size: "big",
      type: "block",
      color: "lightgrey",
      onClick: () => successonClick(),
      __self: undefined,
      __source: {
        fileName: _jsxFileName$P,
        lineNumber: 209,
        columnNumber: 11
      }
    })));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "topupSuccess",
    __self: undefined,
    __source: {
      fileName: _jsxFileName$P,
      lineNumber: 221,
      columnNumber: 10
    }
  }, Dom);
};
TopupSuccess.propTypes = {
  cardText: PropTypes.string,
  name: PropTypes.string,
  showButton: PropTypes.bool,
  successonClick: PropTypes.func,
  // onClickChildrenCard: PropTypes.func,
  data: PropTypes.shape({}),
  balance: PropTypes.string,
  tryagainClick: PropTypes.func
};
TopupSuccess.defaultProps = {
  cardText: '',
  name: '',
  showButton: false,
  successonClick: () => {},
  // onClickChildrenCard: () => { },
  data: {},
  balance: '',
  tryagainClick: () => {}
};

export { Accordion, AutoSuggestion, Button, Carousel, ContentDivider, CreateNewPassword, CreditHistory, CustomTabs, DatePicker, DeliveryPlan, FilterDropdown, HeaderUserDetail, HomeChildrenListItem, InputLabelFloat, InputMultipleValue, LimitCard, Loader, LunchOrderCalendar, MealListing, NutritionConsumption, NutritionInsightAdvice, NutritionItems, OrderStatus, Pagination, Payment, PaymentCard, PieChart, PieChartSlice, ProgressTrack, RadioButton, ReportCardLostSuccess, ResetCheck, ResetDone, ResetPassword, ShareCredit, SignupAddChildAllergy, SignupAddChildDiet, SignupAddChildPhysical, SignupAddChildProfile, SignupAddChildSchool, SignupAddChildSuccess, SignupCreateAccount, Table, Textarea, TitleDescription, ToggleButton, ToggleSeverity, ToggleTabs, Tooltip, TopupAmount, TopupSuccess };
